export default {
  currencyFormat: "#,###.##",
  thousandSeparator: ",",
  salesInvoiceEditor: {
    glAccountName: "Gl Account",
    glAccountNo: "Gl Account No",
  },
  title: {
    confirmDimensionSet: "Confirm Dimension Set",
    ytdAddAdditionalYear: "Add Additional Year (YTD Report Comparison)",
    store: "Store",
    budget: "Budget",
    receivable: "Receivable",
    client: "Client",
    payable: "Payable",
    inventory: "Inventory",
    item: "Item",
    vendor: "Vendor",
    masterData: "Master Data",
    closeIncomeStatement: "Close Income Statement",
    itemsWithIncorrectCosts: "Items With Incorrect Costs",

    storeRequisitionBatch: "Store Requisition Batch",
    generalPostingGroup: "General Posting Group",
    generalProductPostingGroup: "General Product Posting Group",
    generalBusinessPostingGroup: "General Business Posting Group",
    clientPostingGroup: "Client Posting Group",
    vendorPostingGroup: "Vendor Posting Group",
    inventoryPostingGroup: "Inventory Posting Group",
    inventoryPostingGroups: "Inventory Posting Groups",
    bankAccountPostingGroup: "Bank Account Posting Group",
    depositAccountPostingGroup: "Deposit Account Posting Group",
    inventoryReconciliationSetup: "Inventory Reconciliation Setup",

    expenseGeneralProductPostingGroup: "Expense General Product Posting Group",
    expenseGeneralBusinessPostingGroup: "Expense General Business Posting Group",

    vatPostingGroup: "VAT Posting Group",
    vatBusinessPostingGroup: "VAT Business Posting Group",
    vatProductPostingGroup: "VAT Product Posting Group",
    vatPostingSetup: "VAT Posting Setup",

    postingSetup: "Posting Setup",
    generalPostingSetup: "General Posting Setup",
    inventoryPostingSetup: "Inventory Posting Setup",
    userPostingSetup: "User Posting Setup",
    signatureSetup: "Signature Setup",

    generalLedger: "General Ledger",
    chartOfAccount: "Chart of Account",
    chartOfAccountCategory: "Chart of Account Category",
    chartOfAccountCategoryMenu: "COA Category",
    generalLedgerBudget: "General Ledger Budget",
    cashFlowBudget: "Cash Flow Budget",
    dimension: "Dimension",
    dimensionLevel: "Dimension Level",
    dimensionValueType: "Dimension Value Type",
    dimensionValue: "Dimension Value",
    dimensionOption: "Dimension Option",
    coaDimension: "COA Dimension",
    coaDimensionOptions: "COA Dimension Options",
    coaDimensionMatrix: "COA Dimension Matrix",
    updateCoaDimensionMapping: "Update COA Dimension Mapping",
    defaultDimension: "Default Dimension",
    dimensionRule: "Dimension Rule",
    dimensionRules: "Dimension Rules",
    allowedDimensionValues: "Allowed Dimension Values",
    documentDimension: "Document Dimension",
    generalJournal: "General Journal",
    accountReconciliationJournal: "Account Reconciliation Journal",
    newAccountReconciliationJournal: "New Account Reconciliation Journal",
    newPaymentJournal: "New Payment Journal",
    newCashReceiptJournal: "New Cash Receipt Journal",

    generalConfiguration: "General Configuration",
    warehouseLocation: "Warehouse Location",
    accountingPeriod: "Accounting Period",
    inventoryPeriod: "Inventory Period",
    bankAccount: "Bank Account",
    depositAccount: "Deposit Account",
    paymentTerm: "Payment Term",
    generalJournalBatch: "General Journal Batch",
    numberSeries: "Number Series",
    purchaseRequisitionBatch: "Purchase Requisition Batch",
    unitOfMeasurement: "Unit of Measurement",
    defaultUnitOfMeasurement: "Default Input Unit of Measurement",
    baseUnitOfMeasurement: "Base Unit of Measurement",
    inputUnitOfMeasurement: "Input Unit of Measurement",
    inputUnitOfMeasurementID: "Input Unit of Measurement ID",
    inputUnitOfMeasurementName: "Input Unit of Measurement Name",
    generalJournalTemplate: "General Journal Template",
    user: "User",

    purchaseRequest: "Purchase Request",
    purchaseOrder: "Purchase Order",
    purchasing: "Purchasing",
    purchaseReceiving: "Purchase Receipt",
    purchaseReceiveCanceled: "Canceled Purchase Receipt",
    outstandingPurchaseRequest: "Outstanding Purchase Request",
    vatBreakdown: "VAT Breakdown",
    purchaseRequestList: "Purchase Request List",
    storeRequisitionList: "Store Requisition List",
    storeRequisitionDetail: "Store Requisition Detail",
    postedStoreRequisitionList: "Posted Store Requisition List",
    storeRequisition: "Store Requisition",
    updateStoreRequisition: "Update Store Requisition Status",
    outstandingStoreRequisitionList: "Outstanding Store Requisition List",
    outstandingPurchaseRequestList: "Outstanding Purchase Request List",
    outstandingPurchaseRequestDetail: "Outstanding Purchase Request Detail",
    purchasePayableSetup: "Purchase Payable Setup",
    salesReceivableSetup: "Sales Receivable Setup",
    purchaseOrderDetail: "Purchase Order Detail",
    purchaseReceiptDetail: "Purchase Receipt Detail",
    purchaseRequisitionTemplate: "Purchase Requisition Template",
    storeRequisitionTemplate: "Store Requisition Template",
    purchaseRequisition: "Purchase Requisition",
    purchaseRequestDetail: "Purchase Request Detail",
    purchaseInvoiceDetail: "Purchase Invoice Detail",

    currency: "Currency",
    generalLedgerSetup: "General Ledger Setup",
    reportByDimension: "Report By Dimension",
    profitAndLossBudgetSource: "Profit & Loss Budget Source",
    inventorySetup: "Inventory Setup",
    documentFlow: "Document Flow",
    masterDocumentFlow: "Master Document Flow",
    documentFlowSequenceType: "Document Flow Sequence Type",
    purchaseInvoice: "Purchase Invoice",
    purchaseCheck: "Purchase Data Check",
    itemLedgerEntry: "Item Ledger Entry",
    itemJournalBatch: "Item Journal Batch",
    itemJournal: "Item Journal",
    physicalInventoryJournal: "Physical Inventory Journal",
    vendorLedgerEntry: "Vendor Ledger Entry",
    vendorLedgerEntryDetail: "Vendor Ledger Entry Detail",
    clientLedgerEntry: "Client Ledger Entry",
    clientLedgerEntryDetail: "Client Ledger Entry Detail",
    bankAccountLedgerEntry: "Bank Account Ledger Entry",
    bankAccountLedgerEntryDetail: "Bank Account Ledger Entry Detail",
    depositAccountLedgerEntry: "Deposit Account Ledger Entry",
    depositAccountLedgerEntryDetail: "Deposit Account Ledger Entry Detail",
    physicalInventoryLedgerEntry: "Physical Inventory Ledger Entry",
    vatEntry: "VAT Entry",
    valueEntry: "Value Entry",
    itemApplicationEntry: "Item Application Entry",
    averageCostCalculationEntry: "Average Cost Calculation Entry",
    generalJournalEntry: "General Journal Log",
    postedDocuments: "Posted Documents",
    postedPurchaseRequest: "Posted Purchase Request",
    postedPurchaseOrder: "Posted Purchase Order",
    postedPurchaseReceipt: "Posted Purchase Receipt",
    postedPurchaseInvoice: "Posted Purchase Invoice",
    revertPostedPurchaseInvoice: "Revert Posted Purchase Invoice",
    revertPostedPurchaseCreditMemo: "Revert Posted Purchase Credit Memo",
    postedPurchaseCreditMemo: "Posted Purchase Credit Memo",
    postedSalesInvoice: "Posted Sales Invoice",
    postedSalesCreditMemo: "Posted Sales Credit Memo",
    purchaseCreditMemo: "Purchase Credit Memo",
    postedStoreRequisition: "Posted Store Requisition",
    postedReceivableInvoice: "Posted Receivable Invoice",
    changeLineStatus: "Change Line Status",
    entries: "Entries",
    outstandingStoreRequisition: "Outstanding Store Requisition",

    adjustmentEntry: "Adjustment Entry",
    generalLedgerEntry: "General Ledger Entry",
    generalBudgetEntry: "General Budget Entry",
    generalBudgetJournal: "General Budget Journal",
    paymentJournal: "Payment Journal",
    cashReceiptJournal: "Cash Receipt Journal",

    salesInvoice: "Sales Invoice",
    salesCreditMemo: "Sales Credit Memo",
    appliedEntries: "Applied Entries",
    reports: "Reports",
    unapplyClientEntries: "Unapply Client Entries",
    applyClientEntries: "Apply Client Entries",
    unapplyVendorEntries: "Unapply Vendor Entries",
    applyVendorEntries: "Apply Vendor Entries",
    reverseTransaction: "Reverse Transaction",
    vendorBankAccount: "Vendor Bank Account",
    reportSetting: "Report Setting",
    itemJournalMasterTemplate: "Item Journal Master Template",
    generalJournalMasterTemplate: "General Journal Master Template",
    journalVoucher: "Journal Voucher",
    paymentVoucher: "Payment Voucher",
    receivableInvoice: "Receivable Invoice",
    accountReceivableAgingCreditCard: "Account Receivable Aging Credit Card",
    agingCreditCardReport: "Aging Credit Card Report",
    accountReceivablePaymentList: "Account Receivable Payment List",
    accountReceivablePaymentListCard: "Account Receivable Payment List Card",
    accountReceivablePaymentListLedger:
      "Account Receivable Payment List Ledger",
    purchaseRequestApproval: "Purchase Request Approval",
    approval: "Approval",
    printOption: "Print Option",
    purchaseBookOption: "Purchase Book Option",
    inventoryReconciliation: "Inventory Reconciliation",
    entryEditorChangeAccountNumber: "Change Account Number",
    entryEditorChangeDescription: "Change Description",
    entryEditorChangeBankAccount: "Change Bank Account",
    entryEditorChangeAccountNumberAndDescription: "Change Account Number and Description",
    entryEditorChangesLog: "Changes Log",
    accountPayablePaymentList: "Account Payable Payment List",
    deleteBankAccountLedgerEntry: "Delete BALE",
    deleteBankAccountLedgerEntryDialog: "Delete Bank Account Ledger Entry",
    deleteDepositAccountLedgerEntry: "Delete DALE",
    deleteDepositAccountLedgerEntryDialog: "Delete Deposit Account Ledger Entry",
    choose: "Choose",
    reopen: "Re-open",
    gle: "GLE",
    baleDetail: "BALE Detail",
    bale: "BALE",
    daleDetail: "DALE Detail",
    dale: "DALE",
    chooseBaleEntry: "Choose Bale Entry",
    chooseDaleEntry: "Choose Dale Entry",
    confirmReopenClosedEntry: "Confirm Re-open Closed Entry",
    confirmDeleteGLE: "Confirm Delete GLE",
    confirmDeleteBaleDetail: "Confirm Delete BALE Detail",
    confirmDeleteBale: "Confirm Delete BALE",
    confirmDeleteDaleDetail: "Confirm Delete DALE Detail",
    confirmDeleteDale: "Confirm Delete DALE",
    documentApproval: "Document Approval",
    deletePostedInvoice: "Delete Posted Invoice",
    deleteSelectedInvoices: "Delete Selected Invoices",
    deletePostedMemo: "Delete Posted Memo",
    movePurchaseInvoiceLines: "Move Purchase Invoice Lines",
    purchaseRequestApprovalDetail: "Purchase Request Approval Detail",
    purchaseOrderApprovalDetail: "Purchase Order Approval Detail",
    storeRequestApprovalDetail: "Store Request Approval Detail",
    purchaseInvoiceApprovalDetail: "Purchase Invoice Approval Detail",
    interDepartmentTransferApprovalDetail: "Inter Department Transfer Approval Detail",
    withdrawDocumentApproval: "Withdraw Document Approval",
    changeStatus: "Change Status",
    changeStatusPurchaseRequisition: "Change Status Purchase Requisition",
    ve: "VE",
    cle: "CLE",
    vle: "VLE",
    cleDetail: "CLE Detail",
    vleDetail: "VLE Detail",
    chooseVeEntry: "Choose VE Entry",
    chooseCleEntry: "Choose CLE Entry",
    chooseVleEntry: "Choose VLE Entry",
    confirmDeleteCleDetail: "Confirm Delete CLE Detail",
    confirmDeleteCle: "Confirm Delete CLE",
    confirmDeleteVleDetail: "Confirm Delete VLE Detail",
    confirmDeleteVle: "Confirm Delete VLE",
    confirmDeleteVe: "Confirm Delete VE",
    deleteClientLedgerEntry: "Delete CLE",
    deleteClientLedgerEntryDialog: "Delete Client Ledger Entry",
    deleteVendorLedgerEntry: "Delete VLE",
    deleteVendorLedgerEntryDialog: "Delete Vendor Ledger Entry",
    deleteValueEntry: "Delete VE",
    deleteValueEntryDialog: "Delete Value Entry",
    deleteGeneralJournalEntryDialog: "Delete General Journal Log",
    updateWitholdingTax: "Update Witholding Tax",
    adjustmentTools: "Adjustment Tools",
    adjustSingleEntry: "Adjust Single Entry",
    adjustSOH: "Adjust SOH",
    adjustCostItemEntries: "Adjust Cost Item Entries",
    adjustPostingDate: "Adjust Posting Date",
    documentAttachment: "Document Attachment",
    recallJournal: "Recall Journal",
    reverseJournal: "Reverse Journal",
    inventoryAccountBalanceDetail: "Inventory Account Balance Detail",
    recalled: "Recalled",
    changeClient: "Change Client",
    itemCostPerLocation: "Item Cost per Location",
    invoiceEmailLog: "Invoice Email Log",
    integration: "Integration",
    interDepartmentTransferDetail: "Inter Department Transfer Detail",
    revaluationJournalAllItems: "Revaluation Journal All Items",
    revertPostedSalesInvoice: "Revert Posted Sales Invoice",
    generalLedgerEntryChangesLogs: "General Ledger Entry Changes Logs",
    changeItem: "Change {item}",
    itemJournalLog: "Item Journal Log",
    changesLogs: "Changes Logs",
    cancelledPurchaseReceipts: "Cancelled Purchase Receipts",
    salesInvoiceLine: "Sales Invoice Line",
    selfBilledInvoice: "Self-Billed Invoice",
    taxIntegrationLog: "Tax Integration Log",
    printoutLayout: "Printout Layout",
    approvalDocumentWithdrawal: "Approval Document Withdrawal",
    deleteEntries: "Delete Entries",
    confirmDeletePurchaseInvoice: "Confirm Delete Purchase Invoice",
    interDepartmentTransfer: "Inter Department Transfer",
    interDepartmentTransferBatch: "Inter Department Transfer Batch",
  },
  word: {
    entryNo: "Entry No.",
    chooseThePrintingPageSize: "Choose the printing page size",
    changedTo: "To",
    chooseThePurchaseBookOption: "Choose the purchase book option",
    importRejected: "Import rejected. Fix these rows and import again.",
    importWithReservationSuccess: "Imported {invoices} invoices and {reservations} reservations.",
  },
  main: {
    search: "Search",
    account: "Account",
    interimAccount: "Interim Account",
  },
  form: {
    purchaseOrders: "Purchase Orders",
    purchaseRequest: "Purchase Request",
    outstandingPurchaseRequest: "Outstanding Purchase Request",
    receiving: "Receiving",
    info: "Info",
    vendors: "Vendors",
    items: "Items",
    breakdowns: "Breakdowns",
  },
  button: {
    includeClosedInvoice: "Include Closed Invoice",
    includeClosedEntry: "Include Closed Entry",
    directExpense: "set as Direct Expense",
    correction: "Make Fixed Apply Correction",
    setVendor: "Set Vendor",
    preview: "Preview",
    resetEntry: "Reset All Entries",
    manageBankAccount: "Manage Bank Account",
    viewDetail: "View Details",
    viewAppliedEntries: "Applied Entries",
    viewEntries: "View Entries",
    previewUndoReceipt: "Preview Undo Receipt",
    cancelReceipt: "Cancel Receipt",
    previewCancelReceipt: "Preview Cancel Receipt",
    delete: "Delete",
    deleteBy: "Delete by {f}",
    deleteByIleId: "Delete by ILE ID",
    deleteByDocumentNo: "Delete by Document No",
    createCreditMemo: "Create Corrective Credit Memo",
    calculateInventory: "Calculate Inventory",
    recalculateInventory: "Recalculate Inventory",
    refreshUnitCost: "Refresh Unit Cost",
    upload: "Upload",
    download: "Download",
    downloadTemplate: "Download Template",
    previewData: "Preview Data",
    import: "Import",
    view: "View",
    new: "New",
    newSet: "New Set",
    edit: "Edit",
    ok: "Ok",
    cancel: "Cancel",
    save: "Save",
    revert: "Revert",
    recalculateAverageCost: "Recalculate Average Cost",
    add: "Add",
    choose: "Choose",
    print: "Print",
    post: "Post",
    unpost: "Unpost",
    previewPost: "Preview Post",
    printSupplierComparison: "Print Vendor Comparison",
    insertFromTemplate: "Insert From Template",
    applyEntries: "Apply Entries",
    unapplyEntries: "Unapply Entries",
    process: "Process",
    processToPo: "Process To PO",
    reject: "Reject",
    decline: "Decline",
    approve: "Approve",
    undo: "Undo",
    submitApproval: "Submit Approval",
    reopen: "Reopen",
    release: "Release",
    select: "Select",
    selectDimensionValues: "Select Dimension Values",
    close: "Close",
    move: "Move",
    clear: "Clear",
    clearAll: "Clear All",
    saveChange: "Save Changes",
    saveAsTemplate: "Save as Template",
    addNewTemplate: "Add New Template",
    AddFromReceipt: "Add From Receipt",
    reset: "Reset",
    apply: "Apply",
    addFilter: "Add Filter",
    lineStatusFilter: "Line Status Filter",
    navigate: "Navigate",
    reverse: "Reverse",
    forceClose: "Force Close",
    receiveAll: "Set Receive All",
    ClearReceive: "Clear Receive",
    closePeriod: "Close Period",
    reopenPeriod: "Re-Open Period",
    reopenPeriodForce: "Re-Open Period (Force)",
    closeMonthPeriod: "Close Month Period",
    reopenMonthPeriod: "Re-Open Month Period",
    reopenMonthPeriodForce: "Re-Open Month Period (Force)",
    closeYearPeriod: "Close Year Period",
    reopenYearPeriod: "Re-Open Year Period",
    viewPrice: "View Price",
    newItem: "New Item",
    newLine: "New Line",
    splitItem: "Split Item",
    postAndPrint: "Post & Print",
    vendorEntries: "Vendor Entries",
    postBatch: "Post Batch",
    getPostedSalesInvoice: "Get Posted Sales Invoice",
    setQtyToZero: "Set Qty to Zero",
    showOpenOnly: "Show Open Only",
    history: "History",
    released: "Released",
    deleted: "Deleted",
    showData: "Show Data",
    newItemFromPR: "New Item From PR",
    setReconciled: "Set Reconciled",
    unsetReconciled: "Unset Reconciled",
    downloadToGSheet: "To GSheet",
    downloadToExcel: "To Excel",
    downloadToPDF: "To PDF",
    goToSetup: "Go to Setup",
    goToInvReconSetup: "Go to Inventory Reconciliation Setup",
    goToInventorySetup: "Go to Inventory Setup",
    applyEntriesFromInvoice: "Apply Entries from Invoice",
    applyEntriesFromCreditMemo: "Apply Entries from Credit Memo",
    submit: "Submit",
    create: "Create",
    submitForApproval: "Submit For Approval",
    deleteAll: "Delete All",
    approvalDetail: "Approval Detail",
    approvalNotes: "Approval Notes",
    delegate: "Delegate",
    withdraw: "Withdraw",
    previewAdjustCostEntries: "Preview Adjust Cost Entries",
    adjustCostEntries: "Adjust Cost Entries",
    splitInvoice: "Split Invoice",
    selectAll: "Select All",
    unselectAll: "Unselect All",
    back: "Back",
    next: "Next",
    confirm: "Confirm",
    recall: "Recall",
    refresh: "Refresh",
    viewAccount: "View Account",
    viewDimension: "View Dimension",
    undoForceClose: "Undo Force Close",
    adjustValueEntryAmount: "Adjust Value Entry Amount",
    importHOAInvoice: "Import HOA Invoice",
    importInvoiceWithReservation: "Import Invoice with Reservation",
    readSheet: "Read Sheet",
    invoicedOnly: "Invoiced Only",
    updateStatus: "Update Status",
    addDimension: "Add Dimension"
  },
  radio: {
    autoclose: "Autoclose",
    manualclose: "Manualclose",
  },
  excel: {
    excel: "Excel",
    upload: "Upload",
    uploadInsert: "Upload (Insert)",
    uploadUpdate: "Upload (Update)",
    download: "Download",
    downloadTemplate: "Download Template",
    preview: "Preview Data",
    import: "Import",
    cancel: "Cancel",
    importSuccess: "Import successful",
    importFailed: "Import failed",
    downloadFailed: "Failed to download data",
    parseFailed: "Failed to parse Excel file",
    noValidRows: "No valid rows to import",
    noDataRows: "File has no data rows",
    invalidFileType: "Only .xlsx files are supported",
    fileTooLarge: "File must be under {size}MB",
    showingTruncated: "Showing {limit} of {total} rows — all {total} rows will be imported.",
    missingColumns: "Import blocked — missing expected column(s): {columns}. Please re-download the template.",
  },
  select: {
    base: "Select {f}",
  },
  reports: {
    interfaceJournal: "Interface Journal",
    includeDimension: "Include Dimension Columns",
    allVendor: "All Vendor",
    noVendor: "No Vendor",
    vendorList: "Vendor List",
    earliestPostingDate: "Earliest Posting Date",
    latestPostingDate: "Latest Posting Date",
    selectVendor: "Select Vendor",
    detailLocationSummary: "Detail Location Summary",
    pnlFileID: "Profit And Loss Excel File ID {f}",
    exportPnl: "Profit And Loss {f}",
    pnlID: "Profit And Loss ID {f}",
    downloadToExcel: "Download To Excel",
    profitAndLossCurrentMonthConsolidationExcelFileID: "Profit And Loss Current Month Consolidation Excel File ID",
    profitAndLossYTDConsolidationExcelFileID: "Profit And Loss YTD Consolidation Excel File ID",
    profitAndLossYTDSummaryExcelFileID: "Profit And Loss YTD Summary Excel File ID",
    balanceSheetExcelFileID: "Balance Sheet Excel File ID",
    cashFlowExcelFileID: "Cash Flow Excel File ID",
    cashFlowYTDSummaryExcelFileID: "Cash Flow YTD Summary Excel File ID",
    cashFlowByDepartmentExcelFileID: "Cash Flow by Department Excel File ID",
    dailyFlashCostExcelFileID: "Daily Flash Cost Excel File ID",
    DRRExcelFileID: "DRR Excel File ID",
    FBMealCoverExcelFileID: "FB Meal Cover Excel File ID",
    profitAndLossCurrentMonthConsolidationGoogleSheetFileID: "Profit And Loss Current Month Consolidation Google Sheet File ID",
    profitAndLossYTDConsolidationGoogleSheetFileID: "Profit And Loss YTD Consolidation Google Sheet File ID",
    profitAndLossYTDSummaryGoogleSheetFileID: "Profit And Loss YTD Summary Google Sheet File ID",
    balanceSheetGoogleSheetFileID: "Balance Sheet Google Sheet File ID",
    dailyFlashCostGoogleSheetFileID: "Daily Flash Cost Google Sheet File ID",
    DRRGoogleSheetFileID: "DRR Google Sheet File ID",
    FBMealCoverGoogleSheetFileID: "FB Meal Cover Google Sheet File ID",
    TBSummaryGoogleSheetFileID: "Trial Balance Summary Google Sheet File ID",
    TBSummaryExcelFileID: "Trial Balance Summary Excel File ID",
    gsheetTemplateIsNotConfiguredYet: "Ghseet template is not configured yet",
    excelTemplateIsNotConfiguredYet: "Excel template is not configured yet",
    excelTemplateNotUploaded: "Excel template not uploaded yet. Upload it in Master Data > General Configuration > Report Setting.",
    downloadAsMacro: "Download as Macro",
    startInventoryAccountNumber: "Start Inventory Account Number",
    endInventoryAccountNumber: "End Inventory Account Number",
    accountPayableInterim: "Account Payable Interim",
    accountPayableInterimIsNotConfiguredYet: "Account Payable Interim account is not configured yet. Please set it up in Report Setting.",
    accountPayableInterimAccountNotFound: "The configured Account Payable Interim account was not found in the Chart of Accounts.",

    inventoryDiscrepancyReport: "Inventory Discrepancy Report",
    inventoryFoodDiscrepancy: "Inventory Food Discrepancy",
    inventoryBeverageDiscrepancy: "Inventory Beverage Discrepancy",
    invAccBalanceSOHDiscrepancy: "Inventory Account Balance vs SOH Discrepancy",

    financialReport: "Financial Report",
    accountPayableReport: "Account Payable Report",
    accountReceivableReport: "Account Receivable Report",
    inventoryReport: "Inventory Report",
    frontOfficeReport: "Front Office Report",
    balanceSheet: "Balance Sheet",
    balanceSheetYTDSummary: "Balance Sheet YTD Summary",
    trialBalance: "Trial Balance",
    trialBalanceYTD: "Trial Balance YTD",
    profitAndLoss: "Profit And Loss",
    profitAndLossYTDSummary: "Profit And Loss YTD Summary",
    profitAndLossCurrentMonthConsolidation: "Profit And Loss Current Month Consolidation",
    profitAndLossYTDConsolidation: "Profit And Loss YTD Consolidation",
    cashFlow: "Cash Flow",
    cashFlowYTDSummary: "Cash Flow YTD Summary",
    cashFlowNotConfigured: "No cash flow dimension is configured. Add one under General Ledger Setup → Report By Dimension → Cash Flow.",
    cashFlowByDepartment: "Cash Flow by Department",
    cashFlowByDepartmentNotConfigured: "Configure two dimensions under General Ledger Setup → Report By Dimension → Cash Flow by Department: the first is the row axis, the second the column axis.",
    cashFlowMonthToDate: "Month to Date",
    cashFlowYearToDate: "Year to Date",
    cashFlowUnassigned: "Unassigned",
    cashFlowTotal: "TOTAL",
    actualCurrentMonth: "Actual Current Month",
    budgetCurrentMonth: "Budget Current Month",
    actualLastMonth: "Actual Last Month",
    actualLastYear: "Actual Last Year",
    actualYTDCurrentMonth: "Actual YTD Current Month",
    budgetYTDCurrentMonth: "Budget YTD Current Month",
    actualYTDLastYear: "Actual YTD Last Year",

    accountPayableAging: "Account Payable Aging",
    accountPayableInterimAging: "Account Payable Interim Aging",
    accountPayablePaymentList: "Account Payable Payment List",

    accountReceivableAging: "Account Receivable Aging",
    accountReceivableAgingCard: "Account Receivable Aging Card",
    accountReceivablePaymentList: "Account Receivable Payment List",
    accountReceivablePaymentListCard: "Account Receivable Payment List Card",
    accountReceivablePaymentListLedger: "Account Receivable Payment List Ledger",

    inventoryAccountBalanceDetail: "Inventory Account Balance Detail",
    stockOnHand: "Stock on Hand",
    topPurchaseItem: "Top Purchase Item",
    topPurchaseByVendor: "Top Purchase By Vendor",
    topPurchaseByVendorReport: "Top Purchase By Vendor Report",
    vendorReport: "Vendor Report",
    dailyFlashCost: "Daily Flash Cost",
    slowMovingInventory: "Slow Moving Inventory",
    itemExpense: "Item Expense",
    receivingReport: "Receiving Report",
    inventoryReconciliation: "Inventory Reconciliation",
    itemReorder: "Item Reorder",
    outstandingPurchaseOrder: "Outstanding Purchase Order",
    forceClosedPurchaseOrder: "Force Closed Purchase Order",
    purchasingReport: "Purchasing Report",
    inventoryMovementReport: "Inventory Movement Report",
    itemConsumptionReport: "Item Consumption Report",

    guestAccountBalance: "Guest Account Balance",
    FOClosingCashier: "FO Closing Cashier",
    POSClosingCashier: "POS Closing Cashier",
    dailyRevenueReport: "Daily Revenue Report",
    FBMealCover: "FB Meal Cover",
    incomeAudit: "Income Audit",
    budgetRevenue: "Budget Revenue",
    budgetStatistic: "Budget Statistic",
    showGuestAccountName: "Show Guest / Account Name",
    showSalesPersonName: "Show Sales Person Name",
    showContactName: "Show Client Contact Name",
    useReceivableDateAging: "Use Receivable Date Aging",
    agingDate: "Aging Date",
    discrepancyReport: "Discrepancy Report",
    discrepancy: "Discrepancy",
    agingBy: "Aging By",
    arAgingReport: "AR Aging Report",
    cardAgingReport: "Card Aging Report",
    arAgingAccountSetup: "AR Aging Account setup",
    arAgingAccountSetupNotes: "This is used in AR aging report balance discrepancy",
    apAgingAccountSetup: "AP Aging Account setup",
    apAgingAccountSetupNotes: "This is used in AP aging report balance discrepancy",
    arAgingDiscrepancyReport: "AR Aging Discrepancy Report",
    arAgingDiscrepancy: "AR Aging Discrepancy",
    apAgingDiscrepancyReport: "AP Aging Discrepancy Report",
    apAgingDiscrepancy: "AP Aging Discrepancy",
    bankAccountAgingDiscrepancyReport: "Bank Account Aging Discrepancy Report",
    bankAccountAgingDiscrepancy: "Bank Account Aging Discrepancy",
    arAgingCardAndLedger: "Account Receivable Aging Card And Ledger",
    arAgingCardAndLedgerReport: "Account Receivable Aging Card And Ledger Report",
    accountScheduleConsolidation: "Account Schedule Consolidation",
    accountScheduleConsolidationReport: "Account Schedule Consolidation Report",
    accountScheduleConsolidationExcelFileID: "Account Schedule Consolidation Excel File ID",
    accountScheduleConsolidationGoogleSheetFileID: "Account Schedule Consolidation Google Sheet File ID",
    notAvailableForPreview: "{item} is not available for preview. Please download the report to view this data.",
  },
  status: {
    pleaseWait: "Please wait...",
    loadingpleaseWait: "Loading... Please wait",
    exclusiveDownload: "Detailed results are not available for web display. Please use the download option to view the full details.",
    willSendToEmail: "The file is currently being generated and will be sent to {email} upon completion.",
    trialBalanceDetail: {
      generatingData:
        "Generating trial balance details is in progress. Please wait; this may take a while. You can either close the tab/window or redirect to another page; the process will continue running.",
      readyForDownload:
        "The trial balance detail file is now available for download: ",
      sendEmail: "and send to email:",
      exclusiveDownload:
        "The detailed results of the trial balance are not available for web display and can only be accessed exclusively through file download. <br> For datasets with more than 5,000 rows, kindly utilize the Excel download option.",
      gsheeRowLimitExceeded:
        "The row limit for Google Sheets has been exceeded. Please consider downloading the file as an Excel document instead.",
      willSendToEmail: "The trial balance detail file is currently being generated and will be sent to {email} upon completion.",
      csvOptionDownload:
        "For periods longer than one month, kindly use CSV download.",
      rowLimitExceeded:
        "This range has {rows} ledger entries (max {max}). Narrow the date range or use the CSV download.",
    },
    purchaseReceivingDetail: {
      generatingData:
        "Generating receiving report details is in progress. Please wait; this may take a while. You can either close the tab/window or redirect to another page; the process will continue running.",
      readyForDownload:
        "The receiving report detail file is now available for download: ",
      sendEmail: "and send to email:",
      exclusiveDownload:
        "The detailed results of the receiving report are not available for web display and can only be accessed exclusively through file download. <br> For datasets with more than 5,000 rows, kindly utilize the Excel download option.",
      gsheeRowLimitExceeded:
        "The row limit for Google Sheets has been exceeded. Please consider downloading the file as an Excel document instead.",
    },
    commonReportDetail: {
      generatingData:
        "Generating {f1} details is in progress. Please wait; this may take a while. You can either close the tab/window or redirect to another page; the process will continue running.",
      readyForDownload:
        "The {f1} detail file is now available for download: ",
      sendEmail: "and send to email:",
      exclusiveDownload:
        "The detailed results of the {f1} are not available for web display and can only be accessed exclusively through file download. <br> For datasets with more than {f2} rows, kindly utilize the Excel download option.",
      gSheetRowLimitExceeded:
        "The row limit for Google Sheets has been exceeded. Please consider downloading the file as an Excel document instead.",
    },
    disabledDueToQuantityReceived: "Disabled due to the existence of quantity received",
  },
  confirm: {
    processExpiredWarning: "Are you sure you want to expire old entries? Entries older than {x} will be marked as expired. This action can be reverted, but only manually per entry.",
    forceCloseWarning: "Are you sure you want to force close old entries? All entries older than {x} will be permanently closed. This action cannot be undone.",
    revertExpiredWarning: "Are you sure you want to revert expired entries?",
    calculateInventoryFilterWarning: "If the filter below is used, the inventory calculation will create a new entry instead of overwriting the existing one.",
    processing: "Processing, please wait",
    noAccess: "No Access",
    correctionTitle: "Fixed Apply Correction",
    correction: "Are you sure to make correction for {f}",
    receiveAllHeader: "Set to receive All",
    receiveAll: "Set to receive all quantity?",
    receiveAllFailed: "Set Receive All Failed",
    noEntryPreviewPost: "This post has not generate any entries",
    deleteHeader: "Delete {f}",
    deleteCanUndo: "Are you sure you want to delete {f}?",
    delete:
      "Are you sure you want to delete {f}? This process cannot be undone.",
    deleteBatch:
      "Are you sure you want to delete {f1} rows of {f2}? This process cannot be undone.",
    deleteSuccess: "{f} has been deleted successfully!",
    revertSuccess: "{f} has been reverted successfully!",
    revertFailed: "Error, cannot revert {f}.",
    deleteFailed: "Error, cannot delete {f}.",
    updateSuccess: "{f} has been saved successfully!",
    updateFailed: "Error, cannot save {f}.",
    successRecalculateInventory: "Physical Inventory Journal has been recalculated!",
    failedRecalculateInventory: "Error, cannot recalculate Physical Inventory Journal.",
    printFailed: "Error, cannot print {f}.",
    importSuccess: "{f} has been imported successfully!",
    importFailed: "Error, cannot import {f}.",
    dimensionBulkImportSuccess: "{dimensions} dimensions added, {values} values added",
    coaDimensionBulkImportSuccess: "{mappings} mappings added, {rules} rules added",
    dialogClosing: "Dialog Closing",
    releaseSuccess: "{f} has been released successfully!",
    releaseFailed: "Error, cannot release {f}.",
    reopenSuccess: "{f} has been re-opened successfully!",
    reopenFailed: "Error, cannot re-open {f}.",
    reopenFailedAlreadyProcessed:
      "Error, cannot re-open {f}. Order already received",
    closeSuccess: "{f} has been close successfully!",
    closeFailed: "Error, cannot close {f}.",
    restore: "Are you sure you want to restore {f}?",
    restoreHeader: "Restore {f}",
    restoreFailed: "Error, cannot restore {f}.",
    restoreSuccess: "{f} has been restored successfully!",
    setToNonDirectExpense: "Are you sure you want to Set to Non Direct Expense {f}?",
    setToNonDirectExpenseHeader: "Set to Non Direct Expense {f}",
    setToNonDirectExpenseFailed: "Error, cannot Set to Non Direct Expense {f}.",
    setToNonDirectExpenseSuccess: "{f} has been Set to Non Direct Expense successfully!",
    applyEntriesSuccess: "Entries has been applied successfully!",
    applyEntriesFailed: "Error, failed to apply entries {f}.",
    unapplyEntriesSuccess: "Entries has been unapplied successfully!",
    unapplyEntriesFailed: "Error, failed to unapply entries {f}.",
    reverseEntriesSuccess: "Entries has been reversed successfully!",
    reverseEntriesFailed: "Error, failed to reverse entries {f}.",
    postedSuccess: "{f} has been posted successfully!",
    postedFailed: "Error, cannot post {f}.",
    costsUpdated: "Item costs have been updated successfully!",
    costsUpdateFailed: "Error, cannot update item costs.",
    postedFailedUnitCostZero: "Error, cannot post {f}. Unit Cost can't be 0.",
    postHaveNegativeAdjustment:
      "Warning, posting this will add negative adjustment. Proceed?",
    postPositiveAdjustmentNotAllowed:
      "Cannot post: positive adjustment is not allowed for {f}.",
    processSuccess: "{f} has been processed successfully!",
    processedItems: "- {f1} ({f2}), quantity {f3} {f4}",
    processAlready: "These item(s) already processed as PO:<br/>{f}",
    hasZeroUnitCost: "Some items have zero unit cost. Please check again!",
    hasZeroQuantity: "Some items have zero quantity. Please check again!",
    hasZeroStockOnHand: "Some items have zero stock on hand. Please check again!",
    hasQtyGreatedThanStockOnHand: "Some items have quantity greater than stock on hand. Please check again!",
    rejectHeader: "Reject {f}",
    rejectAlready: "These item(s) already rejected:<br/>{f}",
    reject:
      "Are you sure you want to reject {f}?<br/>This process cannot be undone.",
    splitHeader: "Split {f}",
    splitSuccess: "Item has been split successfully!",
    splitFailed: "Error, cannot split item.<br/>{f}",
    splitMultipleFailed: "Error, cannot split more than one item.",
    setVendorSuccess: "{f} has been updated successfully!",
    incorrectCostsWarning: "The following items have unit costs that differ from their stock on hand costs. You can either cancel or update all unit cost automatically.",
    incorrectCostsTitle: "Items With Incorrect Costs",
    incorrectCostsContinueAnyway: "Continue Anyway",
    incorrectCostsUpdate: "Update unit cost",
    incorrectCostsItemCode: "Item Code",
    incorrectCostsLocation: "Location",
    incorrectCostsCurrentUnitCost: "Current Unit Cost",
    incorrectCostsStockOnHandCost: "Stock On Hand Cost",
    incorrectCostsDifference: "Difference",
    incorrectCostsStockOnHand: "Stock On Hand",
    confirmUpdate: "Are you sure you want to update this {f}?",
    confirmDelete: "Are you sure you want to delete this {f}?",
    confirmDeleteMultiple: "Are you sure you want to delete these {f}?",
    cancelReceipt:
      "Are you sure you want to cancel receipt {f}? This process cannot be undone.",
    cancelReceiptSuccess: "{f} has been canceled successfully!",
    cancelReceiptFailed: "Error, cannot cancel {f}.",
    cancelReceiptHeader: "Cancel Receipt {f}",
    undoReceipt:
      "Are you sure you want to undo receipt {f}? This process cannot be undone.",
    undoReceiptSuccess: "Undo {f} success!",
    undoReceiptFailed: "Error, cannot undo {f}.",
    undoReceiptHeader: "Undo Receipt {f}",

    forceCloseHeader: "Force Close {f}",
    forceClose:
      "Are you sure you want to force close {f1} rows of {f2}? This process cannot be undone.",

    addfromReceiptSuccess:
      "{f} has been added succesfully with {d} duplicate found",
    addfromReceiptRejected: "{f} line(s) rejected: {m}",
    incompleteSearch: "{f} need location or item filter",
    postedFailedNoItems:
      "Error, cannot post {f}. Must have at least 1 item to be received.",
    postFailedNoItems:
      "Error, cannot post {f}. Must have at least 1 item on the document.",
    updateFailedOnUnitEmpty:
      "Error, cannot save {f1}.<br/>These item(s) has no Unit of Measurement:<br/>{f2}",
    printFailedNoActiveFlow:
      "Error, cannot print this document.<br/>No Active Document Flow configured on batch {f}.",
    deleteFailedAlreadyReleased:
      "Error, cannot delete {f}.<br/>This document already released.",
    processToPoFailedOnVendorEmpty:
      "Cannot continue the process to Purchase Order. Please fill the purchase request line completely.",
    invalidAmount: "Error, invalid amount for apply entries",
    postedFailedNoItemsOnTable:
      "Error, cannot post batch {f}. Must have at least 1 document on table.",
    postBatchCompleted: "Post Batch completed!",
    failedDocumentToPost: "Some document failed to post:<br/>{f}",
    deleteAllSelected:
      "Are you sure you want to delete all selected items? This process cannot be undone.",
    deleteFailedNoItemsSelected:
      "Error, cannot delete {f}. Must have at least 1 selected item on table.",
    deleteFailedNoItems:
      "Error, cannot delete {f}. Must have at least 1 item on table.",
    setVendorFailedNoItemsSelected:
      "Error, cannot Set Vendor. Must have at least 1 selected item on table.",
    setVatFailedNoItemsSelected:
      "Error, cannot Set VAT. Must have at least 1 selected item on table.",
    deleteFailedForStatus: "Error, cannot delete {f1}. {f2} already {f3}.",
    deleteItemFailedForStatus:
      "Error, cannot delete items. Item status already changed.",
    processedItemsStatus: "- {f1} ({f2}) {f3} {f4} => <b>{f5}</b>",
    reopenFailedProcessedAlready:
      "Some of the items have been processed. Can't Reopen!",
    postBatchConfirm: "Are you sure you want to post all data on table?",
    postSelectedConfirm: "Are you sure you want to post selected document?",
    postSelectedConfirmWithCount: "Are you sure you want to post the {v} selected documents?",
    noItemSelected: "Error, no item selected",
    postSRFailedPostingDateLessThanDocumentDate:
      "Error, cannot post {f}. Posting date can't be before document date.",
    setAllQtyToZero:
      "Are you sure you want to set all quantity to zero? This process cannot be undone.",
    updateLocationHeader: "Update Item Location",
    updateLocation:
      "Do you want to update all location in line into {f}?<br/>This process cannot be undone.",
    setLocationSuccess: "Item location has been updated successfully!",
    allQtyToZeroSuccess: "All quantity has been set to zero successfully!",
    allQtyToZeroFailed: "Error, cannot set all quantity to zero!",
    refreshPhysInvUnitCost:
      "Are you sure you want to refresh all unit cost? This process cannot be undone.",
    refreshPhysInvUnitCostSuccess:
      "All unit cost has been updated successfully!",
    refreshPhysInvUnitCostFailed: "Error, cannot refresh unit cost!",
    itemMassRecalculate:
      "Are you sure you want to recalculate all selected item unit cost? This process cannot be undone.",
    storeRequisitionRefreshUnitCost:
      "Are you sure you want to recalculate all item and refresh all unit cost for all lines in this document? This process cannot be undone.",
    revertPostedStoreRequisition:
      "Are you sure you want to revert this posted store requisition? This process will remove all the entries related to this document and revert the SR into released again. This process cannot be undone.",
    revertPostedStoreRequisitionSuccess:
      "Posted store requisition has been reverted successfully!",
    revertPostedStoreRequisitionFailed:
      "Error, cannot revert posted store requisition!",
    deleteItemLedgerEntry:
      "Are you sure you want to delete this item ledger entry? This process will remove all the entries related to this document. This process cannot be undone.",
    deleteItemLedgerEntrySuccess:
      "Item ledger entry has been deleted successfully!",
    deleteItemLedgerEntryFailed:
      "Error, cannot delete item ledger entry!",
    deleteItemLedgerEntryTypeNotAllowed:
      "This entry type is not allowed to be deleted.",
    itemMassRecalculateSuccess: "All unit cost has been recalculated!",
    itemMassRecalculateFailed: "Error, recalculate unit cost failed!",
    itemMassRecalculateNoData: "Recalculate item not executed, no data found!",
    refreshUnitCostSuccess: "All unit cost has been refreshed!",
    refreshUnitCostFailed: "Error, cannot refresh unit cost!",
    itemTypeIsNotGl: "Item type is not allowed",
    withdrawHeader: "Withdraw {f}",
    withdraw:
      "Are you sure you want to withdraw {f}? This process cannot be undone.",
    withdrawSuccess: "{f} has been withdrawn successfully!",
    delegateSuccess: "{f} has been delegated successfully!",
    delegate:
      "Are you sure you want to delegate <strong>{t}</strong> on behalf of <strong>{f}</strong>? The involved users will be notified.",
    delegateHeader: "Delegate {t}",
    viewReportFailedNoSetup:
      "Cannot view report due to some missing entry on Inventory Reconciliation Setup.<br/>Please complete all setup first!",
    approvalSubmissionSuccess:
      "{f} has been successfully submitted for approval!",
    closeIncomeStatementSuccess:
      "Close Income Statement journal entries has been successfully created. Please see the created journals in the specified batch",
    closeIncomeStatementFailed:
      "Error, Close Income Statement journal creation failed",
    entryEditorSuccess: "Entry has been successfully updated!",
    removeApplyToJournalIdAndAmountToApplyWithId:
      "Remove Applied Journal on ID : {f}",
    removeApplyToJournalIdAndAmountToApplyFailed:
      "Error, cannot remove {f}. The Journal ID still exist.",
    removeApplyToJournalIdAndAmountToApplyErrorFailed:
      "Error, remove applied journal failed",
    removeApplyToJournalIdAndAmountToApplyErrorCheckJournal:
      "Error, cannot remove because of error on check journal",
    removeApplyToJournalIAndAmountToApplydNotAllowed:
      "Remove Applied Journal not allowed",
    submitSuccess: "{f} has been submitted successfully!",
    withdrawDocument:
      "Are you sure you want to withdraw the document? This process cannot be undone.",
    adjustAllConfirmation: "Are you sure want to adjust all items?<br/>This process cannot be undone.",
    adjustConfirmation: "Are you sure want to adjust on filtered items only?<br/>This process cannot be undone.",
    viewReportFailedNoAccountSetup: "Cannot view report. Must have at least 1 or more accounts on setup!",
    defaultDirectExpenseChanged: "Default direct expense is changed",
    overwriteDirectExpenseLineConfirm: "Do you want to overwrite all the line with new default?",
    existingLineRemovalConfirm: "The existing line will be removed. Are you sure?",
    undoForceCloseHeader: "Undo Force Close {f}",
    undoForceClose: "Are you sure you want to undo force close this item?",
    undoForceCloseFailed: "Cannot undo, some items are not force closed yet!",
    errorEmptyLines: "Lines cannot be empty",
    failedGetSOHForItem: "Error, cannot get Stock On Hand for this Line/Item",
    invalidThresholdItems: "- {f1} ({f2}), unit cost {f3} with last direct cost {f4}",
    filteringWillBeReleased: "All filtering condition will be removed, hence all items will be processed. Are you sure?",
    updatePurchaseOrderStatusConfirmation: "Are you sure you want to change the status from '{f1}' to '{f2}'?",
    updatePurchaseOrderStatusConfirmationWithDoc: "Are you sure you want to change the status of Purchase Order '{f1}' from '{f2}' to '{f3}'?",
    updateUnitCostVendorComparisonLowestSuccess: "{f} has been updated with lowest price using vendor comparison!",
    updateUnitCostVendorComparisonLowestFailed: "Error, cannot update unit cost using vendor comparison price (lowest).",
    confirmSendEmail: "Are you sure want to send emails to the selected invoices?",
    areYouSure: "Are you sure?",
    setToCompletelyReceivedConfirmation: "Are you sure want to set this to completely received?",
    unsetCompletelyReceivedConfirmation: "Are you sure want to unset completely received?",
    confirmAction: "Confirm Action",
    areYouSureToAction: "Are you sure you want to {action}?",
    updateCoaDimensionMappingConfirmation: "Are you sure you want to update this mapping?",
    downloadFailedActiveFlowIsEmpty: "Error, cannot download this document.<br/>Current Active Document Flow not configured or still empty.",
  },
  data: {
    changeGLAccount: "Change GL Account",
    enablePrintButtonForOnlyReleasedDocuments: "Enable Print Button only If document status Is Released",
    printGeneralLedgerInformationonPostedDocument: "Print General Ledger Information on Posted Document",
    submittedAt: "Submitted At",
    submittedBy: "Submitted By",
    withdrawalAt: "Withdrawal At",
    withdrawalBy: "Withdrawal By",
    recalledAt: "Recalled At",
    recalledBy: "Recalled By",
    expectedDueDate: "Expected / Due Date",
    documentApprovalType: "Document Approval Type",
    clientLedgerEntryId: "Client Ledger Entry Id",
    vendorLedgerEntryId: "Vendor Ledger Entry Id",
    isReconciled: "Is Reconciled",
    isCloseYearEntry: "Is Close Year Entry",
    totaling: "Totaling",
    defaultDimensionValue: "Default Dimension Value",
    dimensionSetID: "Dimension Set ID",
    currentDimensionSetID: "Current Dimension Set ID",
    dimensionName: "Dimension Name",
    dimensionCode: "Dimension Code",
    showInDocument: "Show in Document",
    showInDocumentHint: "Levels marked Show in Document add their Code and Name columns to: Purchase Request, Purchase Order, Purchase Receipt, Purchase Invoice, Purchase Credit Memo, Store Requisition, Sales Invoice, Sales Credit Memo, General Journal, General Budget Journal, Item Journal, Physical Inventory Journal",
    useGeneralBudgetEntryForPnlBudget: "Use General Budget Entry for P&L Budget",
    optionCode: "Option Code",
    defaultValueCode: "Default Value Code",
    allowed: "Allowed",
    allowedValueCode: "Allowed Value Code",
    dimensionValueName: "Dimension Value Name",
    dimensionValueCode: "Dimension Value Code",
    dimensionValueID: "Dimension Value ID",
    selectAllowedDimensionValues: "Select allowed dimension values for this dimension",
    selectDimensionToViewAllowedValues: "Select a dimension to view allowed values",
    selectedValues: "Selected Values",
    stockOnHand: "Stock on Hand",
    inputStockOnHand: "Input Stock on Hand",
    inputStockOnHandFrom: "Input Stock on Hand (From)",
    inputStockOnHandTo: "Input Stock on Hand (To)",
    stockOnHandFrom: "Stock on Hand (From)",
    stockOnHandTo: "Stock on Hand (To)",
    currentStockOnHand: "Current SOH",
    baseCurrentStockOnHand: "Base Current SOH",
    reconciliationGlAccount: "Default GL Account",
    reconciliationWhtGlAccount: "Withholding Tax Account",
    whtAccountMustDiffer: "Withholding Tax Account must differ from the Default GL Account",
    virtualAccount: "Virtual Account",
    accountName: "Account Name",
    accountNameList: "Account Name List",
    accountNumber: "Account Number",
    bankAccountPostingGroupCode: "Bank Account Posting Group Code",
    bankAccountPostingGroupName: "Bank Account Posting Group Name",
    depositAccountCode: "Deposit Account Code",
    depositAccountName: "Deposit Account Name",
    boDepositAccountCode: "BO Deposit Account Code",
    boDepositAccountName: "BO Deposit Account Name",
    foDepositAccountNo: "FO Deposit Account No",
    foDepositAccountName: "FO Deposit Account Name",
    depositAccountPostingGroupCode: "Deposit Account Posting Group Code",
    depositAccountPostingGroupName: "Deposit Account Posting Group Name",
    reconciliationAccount: "Reconciliation Account",
    reconciliationBankAccount: "Reconciliation Bank Account",
    isReconciliationAccount: "Is Reconciliation Account",
    showOppositeSigninReport: "Show Opposite Sign in Report",
    setWidenedPhysicalInventoryRow: "Set Widened Physical Inventory Row",
    allowChangeItemLastDirectCost: "Allow Change Item Last Direct Cost",
    allowPositiveAdjustmentPhysicalInventory: "Allow Positive Adjustment on Physical Inventory Journal",
    itemVendorPurchaseprice: "Item Vendor Purchase Price",
    startDate: "Start Date",
    endDate: "End Date",
    startDateWithPlaceholderDDMMYYYY: "Start Date (DD-MM-YYYY)",
    endDateWithPlaceholderDDMMYYYY: "End Date (DD-MM-YYYY)",
    purchasePrice: "Purchase Price",
    year: "Year",
    lastIleId: "Last ILE Id",
    inventoryPostingType: "Inventory Posting Type",
    isFlashCostStoreRequisition: "Is Flash Cost Store Requisition",
    isFlashCostPurchaseRequisition: "Is Flash Cost Purchase Requisition",
    requestStatus: "Request Status",
    receiptStatus: "Receive Status",
    created: "Created",
    createdBy: "Created By",
    createdAt: "Created At",
    lastModified: "Last Modified",
    lastModifiedBy: "Last Modified By",
    lastMovement: "Last Movement",
    age: "Age",
    soh: "SOH",
    swiftCode: "SWIFT Code",
    defaultBank: "Default Account",
    destinationName: "Destination",
    destinationID: "Destination ID",
    department: "Department",
    clientInfo: "Client Info",
    clientCode: "Client Code",
    clientName: "Client Name",
    clientId: "Client ID",
    guestName: "Guest Name",
    appliedVendorLedgerEntryId: "Applied Id",
    appliedClientLedgerEntryId: "Applied Id",
    appliedBankAccountLedgerEntryId: "Applied Id",
    appliedDepositAccountLedgerEntryId: "Applied Id",
    defaultGuestInhouseAccountId: "Default Guest in House Account",
    isReceivedCompletely: "Complete Receive",
    termCode: "Term Code",
    termName: "Term Name",
    searchBar: "Search something here...",
    netChange: "Net Change",
    entry: "Entry",
    totalDocument: "Total Document",
    vendorCode: "Vendor Code",
    vendorName: "Vendor Name",
    itemCode: "Item Code",
    itemName: "Item Name",
    itemID: "Item ID",
    itemTypeName: "Item Type Name",
    itemTypeID: "Item Type ID",
    itemDescription: "Item Description",
    itemUnitCost: "Item Unit Cost",
    vatAmount: "VAT Amount",
    autoRecalculateCost: "Auto Recalculate Cost",
    step: "Step",
    allowMultiple: "Allow Multiple",
    posting: "Posting",
    affectedData: "Affected data",
    invoice: "Invoice",
    receipt: "Receipt",
    receiptPosting: "Receipt Posting",
    order: "Order",
    wording: "Wording",
    defaultName: "Default Name",
    defaultRoleName: "DefaultRoleName",
    role: "Role",
    no: "No",
    defaultVatProductPostingGroup: "Default Vat Product Posting Group",
    code: "Code",
    name: "Name",
    conversion: "Conversion",
    description: "Description",
    email: "Email",
    contractValidFrom: "Contract Valid From",
    contractValidTo: "Contract Valid To",
    account: "Account",
    accountNo: "Account No",
    glAccount: "G/L Account",
    glAccountNo: "G/L Account No",
    location: "Location",
    locations: "Locations",
    allLocations: "All Locations",
    itemCodeOrItemName: "Item Code Or Item Name",
    offsetLocation: "Offset Location",
    defaultFromLocation: "Default From Location",
    defaultToLocation: "Default To Location",
    invPostGroup: "Inv.Post. Group",
    accountCode: "Account Code",
    interimAccountName: "Interim Account",
    interimAccountNo: "Interim Account No",
    purchaseAccount: "Purchase Account",
    accrualInterimAccount: "Acc. Interim Account",
    inventoryAdjustmentAccount: "Inv. Adjustment Account",
    expenseInventoryAdjustmentAccount: "Exp. Inv. Adjustment Account",
    directCostAppliedAccount: "Direct Cost Applied Account",
    vatBusPostGroup: "VAT. Bus. Post. Group",
    vatBusPostGroupCode: "VAT. Bus. Post. Group Code",
    vatBusPostGroupID: "VAT. Bus. Post. Group ID",
    vatProductPostingGroup: "VAT. Prod. Post. Group",
    vatProductPostingGroupID: "VAT. Prod. Post. Group ID",
    whtVatProductPostingGroup: "WHT. VAT. Prod. Post. Group",
    genBusPostGroup: "Gen. Bus. Post. Group",
    genBusPostGroupCode: "Gen. Bus. Post. Group Code",
    genBusPostGroupID: "Gen. Bus. Post. Group ID",
    genProdPostGroup: "Gen. Prod. Post. Group",
    genProdPostGroupID: "Gen. Prod. Post. Group ID",
    bankAccPostGroup: "Bank Acc.Post. Group",
    paymentTerm: "Payment Term",
    directExpenseGenBusPostGroup: "Direct Expense Gen.Bus.Post. Group",
    directExpenseGenProdPostGroup: "Direct Expense Gen.Prod.Post. Group",
    directExpenseAdjustmentAccount: "Direct Expense Adjustment Account",
    defaultDirectExpenseGenBusPostGroup: "Default Direct Expense Gen.Bus.Post. Group",
    custPostGroup: "Client Posting Group",
    vendorPostGroup: "Vendor Posting Group",
    showPreviousMonthAdjustment: "Show Previous Months Adjustment",
    noDimensionValue: "(No dimension)",
    isPreviousMonth: "Is Previous Month",
    journalTemplate: "Journal Template",
    journalTemplateId: "Journal Template Id",
    journalBatchId: "Journal Batch Id",
    revenueLineId: "Revenue Line ID",
    noSeries: "No Series",
    defaultLocation: "Default Location",
    prefix: "Prefix",
    startingNumber: "Starting number",
    endingNumber: "Ending number",
    lastNumberUsed: "Last Number used",
    lengthOfNumber: "Length of Number",
    includeYear: "Include Year",
    includeMonth: "Include Month",
    includeDate: "Include Date",
    isEditable: "Is Editable",
    branch: "Branch",
    bankAccountName: "Bank Account Name",
    bankAccountNo: "Bank Account No",
    virtualAccountNo: "Virtual Account No",
    allowPostingFrom: "Allow Posting From",
    allowPostingTo: "Allow Posting To",
    receivableAccount: "Receivable Account",
    receivableAccountNo: "Receivable Account No",
    payableAccount: "Payable Account",
    balanceAccount: "Balance Account",
    accountCategory: "Account Category",
    accountType: "Account Type",
    directPost: "Direct Post",
    blocked: "Blocked",
    vatPercentage: "VAT Percentage",
    startingDate: "Starting Date",
    closed: "Closed",
    endingDate: "Ending Date",
    dueDateCalc: "Due Date Calculation",

    address: "Address",
    city: "City",
    country: "Country",
    phoneNo: "Phone No",
    contactName: "Contact Name",
    unit: "Unit",
    costingMethod: "Costing Method",
    unitCost: "Unit Cost",
    baseUnitCost: "Base Unit Cost",
    inputUnitCost: "Input Unit Cost",
    lastDirectCost: "Last Direct Cost",
    reorderQuantity: "Reorder Quantity",

    totalling: "Totalling",
    totallingFrom: "Totalling From",
    totallingTo: "Totalling To",
    directPosting: "Direct Posting",

    batch: "Batch",
    batchName: "Batch Name",
    lineNo: "Line No",
    postingDate: "Posting Date",
    newPostingDate: "New Posting Date",
    documentNo: "Document No",
    isApplied: "Is Applied",
    amount: "Amount",
    debitAmount: "Debit Amount",
    creditAmount: "Credit Amount",
    inventory: "Inventory",

    vendorAccount: "Vendor Account",
    clientAccount: "Client Account",
    totalAmount: "Total Amount",
    selectedTotalAmount: "Selected Total Amount",
    status: "Status",
    purchasingStatus: "Purchasing Status",
    expectedDate: "Expected Date",
    quantity: "Quantity",
    value: "Value",
    inputQuantity: "Input Quantity",
    inputUom: "Input UoM",
    forceCloseReason: "Force Close Reason",
    unitPrice: "Unit Price",
    totalPrice: "Total Price",
    closedByUser: "Closed By User",
    includeAutoClosed: "Include Auto-Closed",
    baseQuantity: "Base Quantity",
    id: "ID",
    orderDate: "Order Date",
    amountIncVat: "Amount Inc. VAT",
    amountExcVat: "Amount Exc. VAT",
    unitCostIncVat: "Unit Cost Inc. VAT",
    itemNo: "Item No",
    purchaseRequestNo: "PR Number",
    purchaseOrderNo: "PO Number",
    deliveryDate: "Delivery Date",
    quantityOutstanding: "Quantity Outstanding",
    type: "Type",
    balance: "Balance",
    balanceToDate: "Balance To Date",
    subTotal: "Sub Total",
    vat: "VAT",
    totalIncVat: "Total Inc. VAT",
    wht: "WHT",
    vendorDeliveryNo: "Vendor Delivery No.",
    taxRegisterNumber: "Tax Register Number",
    purchaseReceiptNo: "PR No.",
    purchaseReceiptPostingDate: "PR Posting Date",
    poNo: "PO Number",
    salesTaxAccount: "Sales Tax Account",
    purchaseTaxAccount: "Purchase Tax Account",
    total: "Total",
    totalRows: "Total Rows:",
    purchaseRequestSeries: "Purchase Request Series",
    purchaseOrderSeries: "Purchase Order Series",
    purchaseReceiptSeries: "Purchase Receipt Series",
    purchaseInvoiceSeries: "Purchase Invoice Series",
    purchaseInvoiceLabel: "Purchase Invoice Label",
    purchaseReceiptLabel: "Purchase Receipt Label",
    purchaseCreditMemoSeries: "Purchase Credit Series",
    salesInvoiceSeries: "Sales Invoice Series",
    salesCreditMemoSeries: "Sales Credit Series",
    receivableInvoiceSeries: "Receivable Invoice Series",
    symbol: "Symbol",
    transferOrderSeries: "Transfer Order Series",
    defaultCostingMethod: "Default Costing Method",
    quantityReceived: "Quantity Received",
    quantityInvoiced: "Quantity Invoiced",
    quantityPO: "Quantity Ordered",
    quantityToReceive: "Quantity To Receive",
    quantityOrdered: "Quantity Ordered",
    purchaseReceivingList: "Purchase Receipt History List",
    quantityToInvoice: "Quantity To Invoice",
    prNumber: "Purchase Request Number",
    vendorOneName: "Vendor 1",
    vendorOnePrice: "Price 1",
    vendorTwoName: "Vendor 2",
    vendorTwoPrice: "Price 2",
    vendorThreeName: "Vendor 3",
    vendorThreePrice: "Price 3",
    showVendorColumns: "Show Vendor Comparison Column",
    showVendorDetail: "Show Vendor",
    setVatProduct: "Set VAT Product",
    showSOHByInputUOM: "Show Stock on Hand by Input UOM",
    showByInputUOM: "Show by Input UOM",
    expirationDate: "Expiration Date",

    vendorInvoiceNo: "Vendor Invoice No",
    receiptNo: "Receipt No",
    invoiceNo: "Invoice No",
    sourcePurchaseInvoice: "Source Purchase Invoice",
    targetPurchaseInvoice: "Target Purchase Invoice",
    movePreview: "Move Preview",
    from: "From",
    to: "To",
    dueDate: "Due Date",
    documentFlow: "Active Document Flow",
    receivableInvoiceDocumentFlow: "Receivable Invoice Active Document Flow",
    quantityToBeReceive: "Remaining to Receive",
    detail: "Detail",
    purchaseRequisitionTemplate: "Purchase Requisition Template",
    entryType: "Entry Type",
    documentType: "Document Type",
    invoicedQuantity: "Invoiced Quantity",
    ileQuantity: "ILE Quantity",
    ileBaseQuantity: "ILE Base Quantity",
    remainingQuantity: "Remaining Quantity",
    remainingQuantityToInvoice: "Remaining To Invoice",
    outboundIle: "Outbound ILE",
    inboundIle: "Inbound ILE",
    costAmountExpected: "Cost Amount Expected",
    costAmountActual: "Cost Amount Actual",
    valuationDate: "Valuation Date",
    averageCostEntryType: "Average Cost Entry Type",
    glRegisterId: "GL Register Id",
    sourceIdtDocumentNo: "Source IDT Document No",
    reconciledGlRegisterId: "Reconciled by GL Register Id",
    isAdjustment: "Is Adjustment",
    adjustmentSource: "Adjustment Source",
    valuedQuantity: "Valued Quantity",
    applyToEntry: "Apply To Entry No",
    fixedApply: "Fixed Apply",

    removeApplyToJournalIdAndAmountToApply:
      "Remove Applied Journal",
    applyToJournalIdAndAmountToApply: "Apply to Journal Id & Amount To Apply",
    applyToJournalId: "Apply to Journal Id",
    amountToApply: "Amount To Apply",
    applied: "Applied",
    invoiceDate: "Invoice Date",
    remainingAmount: "Remaining Amount",
    remainingAmountIncVat: "Remaining Amount Inc. VAT",
    unapplied: "Unapplied",
    unappliedById: "Unapplied by Id",

    currencyCode: "Currency Code",
    reversed: "Reversed",
    reversedBy: "Reversed By",
    open: "Open",
    vendorInfo: "Vendor Info",
    itemNotOnInventory: "Item not on Inventory",
    dateFilterStart: "Start Date",
    dateFilterEnd: "End Date",
    dateFilter: "Date Filter",
    locationFilter: "Location Filter",
    batchFilter: "Batch Filter",
    itemFilter: "item Filter",
    quantityPhysicalInventory: "Quantity (Physical Inventory)",
    quantityCalculated: "Quantity (Calculated)",

    documentDate: "Document Date",
    requestByUser: "Requested By",
    fromLocation: "From",
    toLocation: "To",
    postingUser: "Posted By",
    posted: "Posted",
    draft: "Draft",
    isPosted: "Is Posted",
    quantityShipped: "Shipped Quantity",
    baseQuantityShipped: "Base Shipped Quantity",
    locationCode: "Location Code",
    locationName: "Location Name",
    chartOfAccountDetail: "Chart of Account Detail",
    taxType: "Tax Type",
    notAvailable: "Not Available",
    notApplicable: "Not Applicable",
    appliesToPostedSalesInvoiceId: "Applied Sales Invoice Id",
    appliesToPostedPurchaseInvoiceId: "Applied Purchase Invoice Id",
    appliesToPostedPurchaseInvoiceNo: "Applied Purchase Invoice No",
    appliesToPostedSalesCreditMemoId: "Applied Sales Credit Memo Id",
    appliesToPostedPurchaseCreditMemoId: "Applied Purchase Credit Memo Id",
    cashDeskMovementId: "Cash Desk Movement Id",
    isForceClosed: "Is Force Closed",
    monthClosed: "Month Closed",
    month1: "1 Month",
    month2: "2 Months",
    month3: "3 Months",
    month4: "4 Months",
    moreThan4Months: "> 4 Months",
    yearClosed: "Year Closed",
    inventoryClosed: "Inventory Closed",
    createYear: "Set for a year",
    includeIncome: "Include closing entry",
    retainedEarningAccount: "Retained Earning Account",
    closeIncomeStatementJournalBatch: "Close Income Statement Journal Batch",
    reviewYtdReportComparisonYear: "Review YTD Report Comparison Year",
    reviewPnlYtdSummaryComparisonYear: "Profit And Loss YTD Summary Comparison Year",
    reviewPnlYtdConsolidationComparisonYear: "Profit And Loss YTD Consolidation Comparison Year",
    reviewBalanceSheetYtdSummaryComparisonYear: "Balance Sheet YTD Summary Comparison Year",
    witholdingTaxDefaultJournalBatch: "Witholding Tax Default Journal Batch",
    showQuantityCalculated: "Show Quantity (Calculated) column",
    setZeroQuantityPhysicalAsBlank: "Set 0 Quantity (Physical Inventory) as blank",
    hideUnitCostColumn: "Hide Unit Cost column",
    hideTotalAmountColumn: "Hide Total Amount column",
    showQuantityAdjusted: "Show Quantity (Adjusted) column",
    showAgedColumn: "Show Aged column",
    showAdjustmentEntry: "Show Adjustment Entry",
    showAgingDays: "Show Aging Days",
    showAsGroup: "Show as {s} group ",
    coaApInterim: "COA AP Interim",
    originalQuantity: "Original Quantity",
    newQuantity: "New Quantity",
    editQuantity: "Edit Quantity",
    requestedQuantity: "Requested Quantity",
    splitQuantity: "Quantity to be split",
    appliesToInvoiceNo: "Applies to Posted Purchase Invoice",
    appliesToSalesInvoiceNo: "Applies to Posted Sales Invoice",
    vendorId: "Vendor ID",
    itemJournalMasterTemplate: "Item Journal Master Template",
    generalJournalMasterTemplate: "General Journal Master Template",

    checkIn: "Checkin",
    checkOut: "Checkout",
    night: "Night",
    roomNo: "Room No",
    receivableInvoiceFooter: "Receivable Invoice Footer",
    receivableInvoiceHeader: "Receivable Invoice Header",
    allowBiggerQuantityInPurchaseOrder:
      "Allow Bigger Quantity in Purchase Order",
    defaultPrintPOGroupLocation: "Default grouped by Location when printing Purchase Order",
    footerAutoColumn: "Footer auto column",
    allowAddNewItemInPOFromPR: "Allow add new item in PO from PR",
    allowFlexibleItemInPO: "Allow flexibility in PO item (manual and PR item)",
    allowChangePriceWhenPOIsReleased: "Allow change price when PO is released",
    allowEditReleasedPOLineZeroQtyReceived: "Allow edit open and released PO line when quantity received is zero",
    allowDeletePrSourcedPoLine: "Allow deletion of PR-sourced PO lines (reverts PR line to Open)",
    overridePrLineFromPo: "Override PR line when PO line is modified",
    useCompanyNameForPrintout: "Use Company Legal Name on printout header",
    useBrandHotelNameForPrintout: "Use Brand Hotel Name on printout header",
    purchaseOrderFooter: "Purchase Order Footer",
    customFooterPurchaseOrderText: "Custom Purchase Order Footer Text",
    customFooterPurchaseRequestText: "Custom Purchase Request Footer Text",
    customFooterPurchaseInvoiceText: "Custom Purchase Invoice Footer Text",
    customFooterPurchaseReceiptText: "Custom Purchase Receipt Footer Text",
    customFooterStoreRequisitionText: "Custom Store Requisition Footer Text",
    lastPrice: "Last Price",
    baseLastPrice: "Base Last Price",
    isFreeOfCharge: "Is Free of Charge",
    defaultFOCashDesk: "Default FO Cash Desk",
    defaultFOCollectionType: "Default FO Collection Type",
    documentTitle: "Document Title",
    startPostingDate: "Start Posting Date",
    endPostingDate: "End Posting Date",
    allVendors: "All Vendors",
    allGroups: "All Groups",
    inventoryGroup: "Inventory Group",
    noteCurrency: "Note: The currency used in this report is {f}",
    otaBookingId: "OTA Booking ID",
    otaBookingClientPostingGroup: "Client Posting Group to Show OTA Booking ID",
    show: "Show",
    hide: "Hide",
    all: "All",
    fromAccount: "From Account",
    toAccount: "To Account",
    noteAccountFromTo:
      "Note: This report will be filtered from account <strong>{f1}</strong> until <strong>{f2}</strong>",
    showDetail: "Show Detail",
    showAllAccounts: "Show All Accounts",
    showAllVendor: "Show All Vendor",
    agedAsOfThisDate: "Aged as of this date",
    grandTotal: "Grand Total",
    receivableNo: "Receivable No",
    showAllClients: "Show All Clients",
    copiedToClipboard: "Copied to clipboard!",
    sortOrder: "Sort Order",
    setAppliesTo: "Set applies to: {f}",
    date: "Date",
    hotelName: "Hotel Name",
    source: "Source",
    vendorSource: "Vendor Source",
    days130: "1-30 Days",
    days3160: "31-60 Days",
    days6190: "61-90 Days",
    days91120: "91-120 Days",
    days120: ">120 Days",
    periodLabel: "{d1} to {d2}",
    downloadGSheet: "Download GSheet",
    downloadExcel: "Download Excel",
    downloadPDF: "Download PDF",
    downloadCSV: "Download CSV",
    downloadPrintoutPDF: "Download Printout PDF",
    report: "Report",
    period: "Period",
    group: "Group",
    totalCost: "Total Cost",
    totalCostAdjust: "Total Cost Adjust",
    totalAdjustment: "Total Adjustment",
    lineStatus: "Line Status",
    useSystematicApproval: "Use Systematic Approval",
    itemType: "Item Type",
    article: "Article",
    articleType: "Article Type",
    baseSellingPrice: "Base Selling Price",
    costPercentage: "Cost %",
    headerNoSeries: "Header No Series",
    lineNoSeries: "Line No Series",
    lineDocumentNo: "Line Document No",
    outlet: "Outlet",
    useSystematicApprovalDML: "Use Systematic Approval (DML)",
    showWithdrawApproval: "Show Withdraw Approval",
    setDefaultDirectExpense: "Set Default Direct Expense",
    notesOrReason: "Notes / Reason",
    user: "User",
    approved: "Approved",
    rejected: "Rejected",
    declined: "Declined",
    preparedBy: "Prepared By",
    checkedBy: "Checked By",
    approvedBy: "Approved By",
    approverName: "Approver Name",
    sequence: "Sequence",
    flowOrder: "Flow Order",
    priority: "Priority",
    defaultPurchaseRequestPriority: "Default Purchase Request Priority",
    defaultDirectExpenseItemJournalBatch: "Default Direct Expense Item Journal Batch",
    earliest: "Earliest",
    latest: "Latest",
    showSummary: "Show Summary",
    delegatedTo: "Delegated To",
    footerText: "Footer Text",
    formattingNotes:
      "These formatting tags only can be applied to each line: *bold* _italic_",
    showHotelLogo: "Show hotel logo",
    showHotelAddress: "Show hotel address",
    food: "Food",
    beverage: "Beverage",
    material: "Material",
    engineering: "Engineering",
    showEngineering: "Show Engineering account on a separate tab",
    coaID: "COA ID",
    addAccount: "Add Account",
    selectAccountName: "Select Account Name",
    selectDimensionValue: "Select Dimension Value",
    restore: "Restore",
    setToNonDirectExpense: "Set to Non Direct Expense",
    includeApprovalNotes: "Include Approval Notes",
    reviewedBy: "Reviewed By",
    reviewedAt: "Reviewed At",
    delegatedAt: "Delegated At",
    delegatedBy: "Delegated By",
    delegatedFrom: "Delegated From",
    isOpen: "Is Open",
    showAllItems: "Show All Items",
    hideUnopenedItems: "Hide Unopened Items",
    summaryByLocation: "Summary by Location",
    showAllBanks: "Show All Banks",
    splitVendorDescription: "Split Vendor Description",
    processToPoCopyDescription: "Process to PO Copy Description",
    showCurrentSohInPurchaseRequest: "Show Current SOH in Purchase Request",
    showCurrentSohInPurchaseOrder: "Show Current SOH in Purchase Order",
    creditAccount: "Credit Account",
    debitAccount: "Debit Account",
    defaultCreditAccount: "Default Credit Account",
    defaultDebitAccount: "Default Debit Account",
    creditAccountName: "Credit Account Name",
    debitAccountName: "Debit Account Name",
    defaultCreditAccountName: "Default Credit Account Name",
    defaultDebitAccountName: "Default Debit Account Name",
    totalCredit: "Total Credit",
    totalDebit: "Total Debit",
    totalLedger: "Total Ledger",
    totalPayment: "Total Payment",
    summary: "Summary",
    hideAmountInPurchaseRequestPrintout:
      "Hide Amount in Purchase Request Printout",
    showTotalCostInPurchaseRequestPrintVendorComparison:
      "Show Total Cost in Purchase Request Print Vendor Comparison",
    enableDescriptionCopyToRemark:
      "Enable Description Copy to Remark on Purchase Request",
    allowSOHZeroWhenStoreRequisitionIsSaved:
      "Allow SOH Zero when Store Requisition is Saved",
    allowRequestedQtyBiggerThanSoh:
      "Allow Requested Qty Bigger than SOH",
    allowFreeOfChargeOnDirectExpense:
      "Allow Free of Charge on Direct Expense",
    allowMultilineDescription:
      "Allow Multi-line Description on PR/PO",
    showUpdateLowestCostVendorComparisonPurchaseRequest:
      "Show Update Lowest Cost Vendor Comparison in Purchase Request",
    useLastDirectCostWhenNoContract:
      "Use Last Direct Cost when No Contract Price Found",
    useLastDirectCostWhenNoContractNote:
      "When Assigning Vendor in Outstanding Purchase Request and Contract Price is Not Available, then Overwrite User Input and Use Last Direct Cost (This is also applied for Purchase Order)",
    useExtendedPRDescriptionLength:
      "Use Extended PR Description Length (255 characters)",
    allowApproverEditQuantityLessThanOriginal:
      "Allow Approver to Edit Quantity less than original",
    allowEditPurchaseRequestInApproval:
      "Allow Edit Purchase Request in Approval",
    allowEditPurchaseRequestInApprovalNote:
      "Only users who are NOT in the approval list can edit. This works together with the 'Allow User to Modify PR in Approval' permission.",
    itemCodeGeneratedBySystem: "Item code will be generated by system",
    mdrFee: "Merchant Disc. Rate {f} (%)",
    batchHasMdrFee: "Batch <strong>{f}</strong> has Merchant Discount Rate options:",
    whtFee: "Withholding Tax (%)",
    batchHasWhtFee: "Withholding tax <strong>{f} %</strong> is applied to this batch.",
    batchHasWhtOptions: "Withholding tax rate:",
    freePercentage: "Free Percentage",
    feeRoundingDigits: "Fee Rounding Digits (0-3)",
    feeRoundingDigitsRange: "Fee Rounding Digits must be a whole number from 0 to 3",
    reconciliationFeeRoundingDigits: "Reconciliation Fee Rounding Digits (0-3)",
    reconciliationFeeRoundingDigitsHint: "Decimals kept on the merchant discount and withholding tax amounts in Account Reconciliation Journal Apply Entries",
    showZeroBalance: "Show Zero Balance",
    targetEntry: "Target Entry",
    approvalPrintout: "Approval Printout",
    document: "Document",
    outstanding: "Outstanding",
    documentsSelected: "documents selected",
    documentSelected: "document selected",
    defaultVendorSetup: "Default Setup for Vendor",
    defaultClientSetup: "Default Setup for Client",
    defaultItemSetup: "Default Setup for Item",
    noVat: "No VAT",
    purchaseOrderDocumentFlow: "Purchase Order Document Flow",
    dailyMarketListDocumentFlow: "Daily Market List Document Flow",
    remark: "Remark",
    deleteRemark: "Delete Remark",
    taxIdentificationNumber: "Tax Identification Number",
    attachment: "Attachment",
    fileFormat: "File Format",
    adjustAllItems: "Adjust All Items",
    adjustFilteredItems: "Adjust Filtered Items",
    adjustItem: "Adjust Item",
    showItemDetail: "Show Item",
    showClientDetail: "Show Client",
    showPurchaseBook: "Show Purchase Book",
    queryDate: "Query Date",
    queryAdjustmentDate: "Query and Adjustment Date",
    adjustmentPostingDate: "Adjustment Posting Date",
    valueEntryID: "Value Entry ID",
    costAmountAdjustment: "Cost Amount Adjustment",
    viewData: "View Data",
    ileID: "ILE ID",
    lastValueEntryID: "Last Value Entry ID",
    unitCostThreshold: "Unit Cost Threshold",
    unitCostThresholdUsingLastDirectCost: "Unit Cost Threshold using last direct cost",
    minUnitCost: "Minimum Unit Cost (%)",
    maxUnitCost: "Maximum Unit Cost (%)",
    isReversed: "Is Reversed",
    reversedPostingDate: "Reversed Posting Date",
    descriptionForVendor: "Description (for Vendor)",
    remarkInternalOnly: "Purchasing Remark (internal only)",
    remarkInternalNoteForPurchasingOnly: "Remark (internal note for Purchasing only)",
    isDirectExpense: "Is Direct Expense",
    isDML: "Is DML",
    inputUOMID: "Input UoM ID",
    inputUOMCode: "Input UoM Code",
    inputUOMName: "Input UoM Name",
    transferOrder: "Transfer Order",
    negativeAdjustment: "Negative Adjustment",
    quantityEqualZero: "Qty = 0",
    quantityGreaterThanZero: "Qty > 0",
    costNegative: "Cost Negative",
    groupByLocation: "Group by Location",
    taxNumberSeries: "Tax Number Series",
    taxCompany: "Tax Company",
    taxExpiryDate: "Tax Expiry Date",
    taxPhone: "Tax Phone",
    taxEmail: "Tax Email",
    taxReceiptNo: "Tax Receipt No.",
    unitNo: "Unit No.",
    unitOwnerName: "Unit Owner Name",
    company: "Company",
    selectedItems: "Selected items",
    hoaCompanyName: "HOA Company Name",
    hoaRoomType: "HOA Room Type",
    hoaUnitNo: "HOA Unit No.",
    emailTemplate: "Email Template",
    salesInvoiceSendEmailTemplate: "Sales Invoice Send Email Template",
    templateVariables: "Template Variables",
    exampleTemplate: "Example Template",
    invoiceLabelSetup: "Invoice Label Setup",
    groupByVendor: "Group by Vendor",
    showAllARCard: "Show All A/R Card",
    setToCompletelyReceived: "Set to Completely Received",
    unsetCompletelyReceived: "Unset Completely Received",
    updatePurchaseOrderStatus: "Update Purchase Order Status",
    updatePurchaseOrderStatusDescription: "Select a new status for the purchase order from the dropdown below.",
    currentStatus: "Current Status",
    newStatus: "New Status",
    preview: "Preview",
    printPreview: "Print Preview",
    descriptionMultiLineHint: "Press Enter or type ; (semicolon) to add a new line",
    defaultChartOfAccount: "Default Chart of Account",
    defaultCOAAmount: "Default COA Amount",
    defaultDescription: "Default Description",
    salesInvoiceNumberSeries: "Sales Invoice Number Series",
    invoiceHeaderAddress: "Invoice Header Address",
    openingInventory: "Opening Inventory",
    incomingInventory: "Incoming Inventory",
    closingInventory: "Closing Inventory",
    inventoryAvailable: "Inventory Available",
    grossConsumption: "Gross Consumption",
    creditsConsumption: "Credits - Consumption",
    creditsComplimentaryCost: "Credits - Complimentary Cost",
    creditsInterDepartmentTransfer: "Credits - Inter Department Transfer",
    otherAdjustment: "Other Adjustment",
    netConsumption: "Net Consumption",
    netBeverageSales: "Net Beverage Sales",
    netFoodSales: "Net Food Sales",
    costOfSales: "Cost of Sales",
    debitCost: "Debit Cost",
    show0Quantity: "Show 0 Quantity",
    selectedLocations: "Selected Locations",
    selectedInventoryPostingGroups: "Selected Inventory Posting Groups",
    noItemsSelected: "No items selected",
    noLocationsSelected: "No locations selected",
    noInventoryPostingGroupsSelected: "No inventory posting groups selected",
    generalSetup: "General Setup",
    onlyShowSameQuantity: "Only Show Same Quantity",
    excludedHotel: "Excluded Hotel",
    idExcludedAutomatically: "IDs below {item} are excluded automatically",
    ileDocumentNo: "ILE Document No",
    adjust: "Adjust",
    importFromExcel: "Import from Excel",
    chooseFile: "Choose File",
    previewData: "Preview Data",
    adjustingPleaseWait: "Adjusting, please wait...",
    showCoaDestination: "Show COA Destination",
    defaultPrintShowCoaDestination: "Default Print Show COA Destination",
    hideWhtWhenZero: "Hide WHT When Amount Is Zero",
    directExpense: "Direct Expense",
    movementType: "Movement Type",
    excelFile: "Excel File",
    businessRegistrationNumber: "Business Registration Number",
    appliedInMalaysia: "Currently applied in Malaysia",
    inventoryAvailableFormula: "Opening + Incoming + Debit",
    grossConsumptionFormula: "Available - Closing",
    otherAdjustmentFormula: "Gross Consumption - Complimentary Cost - Inter Department",
    journalDetail: "Journal Detail",
    sohDate: "SOH Date",
    revaluationJournal: "Revaluation Journal",
    revaluateCost: "Revaluate Cost",
    purchaseCost: "Purchase Cost",
    getPurchaseCost: "Get Purchase Cost",
    valueEntriesToAdjust: "Value Entries to Adjust",
    getValueEntriesToAdjust: "Get Value Entries to Adjust",
    processAdjustment: "Process Adjustment",
    updateUnitCost: "Update Unit Cost",
    unitCostPurchase: "Unit Cost Purchase",
    expectedTotalCost: "Expected Total Cost",
    currentTotalCost: "Current Total Cost",
    currentUnitCost: "Current Unit Cost",
    purchaseUnitCost: "Purchase Unit Cost",
    diffUnitCost: "Diff Unit Cost",
    locationID: "Location ID",
    minimumCostDifference: "Minimum Cost Difference",
    showInvoiceTaxBreakdown: "Show Invoice Tax Breakdown",
    documentStartDate: "Document Start Date",
    documentEndDate: "Document End Date",
    beginning: "Beginning",
    beginningQty: "Beginning Qty",
    beginningValue: "Beginning Value",
    incomingQty: "Incoming Qty",
    outgoingQty: "Outgoing Qty",
    endingQty: "Ending Qty",
    endingValue: "Ending Value",
    averagePrice: "Average Price",
    changeAppliedSalesInvoiceID: "Change Applied Sales Invoice ID",
    currentAppliedSalesInvoiceID: "Current Applied Sales Invoice ID",
    newAppliedSalesInvoiceID: "New Applied Sales Invoice ID",
    changeAppliedID: "Change Applied ID",
    taxNo: "Tax No.",
    taxID: "Tax ID",
    showTaxForm: "Show Tax Form",
    taxNoLabel: "Tax No. Label",
    taxIDLabel: "Tax ID Label",
    additionalTopMargin: "Additional Top Margin",
    additionalTopMarginHints: "Extra top margin space for receivable invoice printing",
    endingBalance: "Ending Balance",
    ledgerMutation: "Ledger Mutation",
    display: "Display",
    receiptDate: "Receipt Date",
    aging: "Aging",
    detailByDay: "Detail by Day",
    showPODetail: "Show PO Detail",
    logNo: "Log No",
    itemJournalLogSeries: "Item Journal Log Series",
    printOptions: "Print Options",
    allowChangeUnitCostGreaterThanOriginal: "Allow change unit cost greater than original",
    allowChangeUnitCostLessThanOriginal: "Allow change unit cost less than original",
    actual: "Actual",
    budget: "Budget",
    deliveryNo: "Delivery No",
    showVendorDeliveryNoOnPrintout: "Show Vendor Delivery Number on printout",
    amountWithCurrency: "Amount ({c})",
    balanceWithCurrency: "Balance ({c})",
    centerHotelLogo: "Display the hotel logo in the center of the paper",
    businessRegistrationNumberNew: "Business Registration Number (New)",
    businessActivityDescription: "Business Activity Description",
    sstRegistrationNumber: "SST Registration Number",
    msicCodeNumber: "MSIC Code Number",
    msicDescription: "MSIC Description",
    totalBalance: "Total Balance",
    showPostingDateColumn: "Show Posting Date column",
    tin1Label: "TIN 1 Label",
    tin1Value: "TIN 1 Value",
    tin2Label: "TIN 2 Label",
    tin2Value: "TIN 2 Value",
    welcomeText: "Dear Sir/Madam,\nThank you for choosing {h} - please find enclosed the following invoice:",
    paidAmount: "Paid Amount",
    remaining: "Remaining",
    allowCreateNewSetPaymentJournal: "Allow Create New Set of Payment Journal",
    createPaymentJournal: "Create Payment Journal",
    createCashReceiptJournal: "Create Cash Receipt Journal",
    allowCreateNewSetCashReceiptJournal: "Allow Create New Set of Cash Receipt Journal",
    journalNotAllowForDirectPosting: "Journals for {f}, is not allowed for direct posting",
    journalHasZeroValue: "Journals for {f}, has zero value",
    journalNotBalanced: "Journals for {f}, not balanced",
    distributeAmount: "Distribute Amount",
    distributeAmountEnablement: "Add at least one bank account first to enable this option",
    distributeAmountMessage: "This will automatically distribute the total amount to the bank account",
    allowDirectReleasePO: "Allow Direct Release PO",
    statistic: "Statistic",
    includedInGop: "Included in GOP",
    secondaryAccountNo: "Secondary Account No",
    chequeNumber: "Cheque Number",
    bankCode: "Bank Code",
    showSignatureOnApproval: "Show Signature on Approval",
    onBehalfOfLabel: "On Behalf Of Label",
    sendEmail: "Send Email",
    useHOAInvoice: "Use HOA Invoice",
    useImportWithReservation: "Use Import with Reservation",
    includeReservationDetail: "Include reservation detail",
    telephone: "Telephone",
    mobilePhone: "Mobile Phone",
    purchaseOrderNO: "Purchase Order No",
    requestNo: "Request No",
    costCenter: "Cost Center",
    tax: "Tax",
    loc: "Loc",
    uom: "UoM",
    qty: "Qty",
    disc: "Disc",
    supplierAddress: "Supplier Address",
    voucherNo: "Voucher No",
    refNo: "Ref No",
    paymentDueDate: "Payment Due Date",
    sortBy: "Sort by",
    showCustomerAccountType: "Show Customer Account Type",
    lockPostingDateTheSameAsWorkingDateInFO: "Lock Posting Date the same as Working Date in FO",
    lockPostingDateTheSameAsWorkingDateInFONote: "For Cash ReceiptJournal and Account Reconciliation Journal",
    showPositive: "Show Positive",
    showBankAccountOnPaymentListReport: "Show Bank Account on all Payment List Report",
    footerFontType: "Footer Font Type",
    standardFontHint: "Standard font by system",
    monospaceFontHint: "Every character, including letters, numbers, and spaces, occupies the same horizontal width",
    signatureAlignment: "Signature Alignment",
    printingDateTime: "Printing Date Time",
    purchaseRequestExpiredRange: "Purchase Request Expired Range (days)",
    purchaseOrderExpiredRange: "Purchase Order Expired Range (days)",
    purchaseRequestMaxBackdatedDays: "Maximum Backdated Days",
    purchaseOrderMaxBackdatedDays: "Maximum Backdated Days",
    purchaseInvoiceMaxBackdatedDays: "Maximum Backdated Days",
    storeRequisitionMaxBackdatedDays: "Maximum Backdated Days",
    postPurchaseInvoice: "Post Purchase Invoice",
    amountDue: "Amount Due",
    periodDate: "Period Date",
    parafInitial: "Paraf / Initial",
    showContactNameOnPrintSummary: "Show contact name on print summary",
    automaticFillInvoiceNo: "Automatic fill Invoice No with Vendor Delivery No",
    showPrintedDateTime: "Show Printed Date Time",
    printedAt: "Printed at",
    chargeDate: "Charge Date",
    banquet: "Banquet",
    paymentStatus: "Payment Status",
    useCompanyHeaderAndLogoOnPrintout: "Use Company Header and Logo on printout header",
    supplierAndHotelVatLabel: "Supplier and Hotel VAT Label",
    supplierInfo: "Supplier Info",
    shipToBillTo: "Ship To / Bill To",
  },
  validation: {
    physicalQuantityNegative: "Physical quantity cannot be negative. Enter the counted quantity (0 if none).",
    idtDeleteOnlyOpen: "Only an open or declined transfer that is not posted can be deleted",
    baseRequired: "Field is required",
    contractValidToBeforeFrom: "Contract Valid To cannot be earlier than Contract Valid From",
    maxBackdatedDaysRange: "Enter a whole number of days between 0 and 30",
    dimensionAlreadyInList: "This dimension already has a value in the list. Edit that row instead of adding a new one.",
    incompleteDimensionRow: "Every row needs both a dimension and a value. Complete or remove the unfinished row.",
    dimensionsNotLoaded: "The current dimensions could not be loaded. Close and reopen this dialog before saving.",
    completeRequiredFields: "Please complete all required fields before posting. Check highlighted fields in the table.",
    required: "{f} is required",
    longerThan: "{f} must not be longer than {v} characters",
    lineMoreThan: "{f} line must not be more than {v} lines",
    exceed: "{f} must not be exceed {v}",
    dateNotAfter: "'{f1}' date should not be after '{f2}'",
    dateNotBefore: "'{f1}' date should not be before '{f2}'",
    dateNotBefore2: "{f1} date should not be before {f2} date ({f3})",
    dateNotBefore3: "{f1} date should not be before {f2} date",
    unitCostExceedOrBelowLastPrice: "Unit cost cannot be above {v1} or below {v2} from last price",
    greaterThan: "Value should be greater than {v}",
    quantityGreaterThanRequested: "Quantity cannot be greater than the requested quantity ({v})",
    linesTotalCannotBeNegative: "Total of all lines cannot be negative",
    generalProductPostingGroupRequired: "General Product Posting Group is required, please select from the dropdown",
    inventoryPostingGroupRequired: "Inventory Posting Group is required, please select from the dropdown",
    baseUnitOfMeasurementRequired: "Base Unit of Measurement is required, please select from the dropdown",
    defaultUnitOfMeasurementRequired: "Default Unit of Measurement is required, please select from the dropdown",
    maxLines: "String should not exceed {f} lines",
    cannotPostWhenUseSystematicApproval: "Cannot post purchase invoice when use systematic approval",
    fourDigitYear: "Enter a 4-digit year",
  },
  textFormat: {
    addFromReceipt: "Add from Receipt : {f} ",
  },
  l: {
    add: "Add",
    addCashDesk: "Add Cash Desk",
    addChannel: "Add Channel",
    addCity: "Add City",
    addChannelClientCompositionMapping:
      "Add Channel Client Composition Mapping",
    addChannelHotelRateCodeMapping: "Add Channel Hotel Rate Code Mapping",
    addChannelHotelRoomTypeMapping: "Add Channel Hotel Room Type Mapping",
    addCountry: "Add Country",
    addCreditCardType: "Add Credit Card Type",
    addGeneralJournal: "Add General Journal",
    addJournalAccountType: "Add Journal Account Type",
    addJournalBatch: "Add Journal Batch",
    addJournalTemplate: "Add Journal Template",
    addRoomStatus: "Add Room Status",
    addRoomType: "Add Room Type",
    adminCode: "Admin Code",
    adminName: "Admin Name",
    adminNameAscii: "Admin Name ASCII",
    adminType: "Admin Type",
    and: "and",
    backOffice: "Back Office",
    bankAccount: "Bank Account",
    bankAccountId: "Bank Account ID",
    beverage: "Beverage",
    beverageToday: "Beverage Today",
    bookingSource: "Booking Source",
    breakdownListAt: "Breakdown List at",
    breakdownListOf: "Breakdown List of",
    cancel: "Cancel",
    cancelProcess: "Cancel Process",
    capital: "Capital",
    cashDesk: "Cash Desk",
    cents: "cents",
    changeClientPostingGroup: "Change Client Posting Group",
    channel: "Channel",
    channelAgencyCode: "Channel Agency Code",
    channelClientCompositionMapping: "Channel Client Composition Mapping",
    channelHotelRateCodeMapping: "Channel Hotel Rate Code Mapping",
    channelHotelRoomTypeMapping: "Channel Hotel Room Type Mapping",
    channelId: "Channel ID",
    channelManager: "Channel Manager",
    channelRateCode: "Channel Rate Code",
    channelRoomType: "Channel Room Type",
    channelRoomTypeCode: "Channel Room Type Code",
    city: "City",
    cityAlt: "City Alt",
    cityAscii: "City ASCII",
    code: "Code",
    country: "Country",
    countryId: "Country ID",
    credit: "Credit",
    creditCard: "Credit Card",
    creditCardType: "Credit Card Type",
    client: "Client",
    clientNo: "Client No.",
    clientLedger: "Client Ledger",
    currencyID: "Currency ID",
    currencyName: "Currency Name",
    dailyFlashCostReport: "Daily Flash Cost Report",
    dashboard: "Dashboard",
    defaultBookingSource: "Default Booking Source",
    defaultMarketSegment: "Default Market Segment",
    delete: "Delete",
    deleteConfirmation: "Delete Confirmation",
    density: "Density",
    description: "Description",
    documentNo: "Document No.",
    documentType: "Document Type",
    documentFlowNotFound: "Document flow with code {f} not found",
    downloadExcel: "Download Excel",
    downloadGSheet: "Download GSheet",
    downloadPDF: "Download PDF",
    downloadReport: "Download Report",
    downloadReportToGSheet: "Download Report to GSheet",
    downloadReportToGSheetMacro: "Download Report to GSheet (Macro)",
    downloadReportToExcel: "Download Report to Excel",
    downloadReportToExcelMacro: "Download Report to Excel (Macro)",
    edit: "Edit",
    editCashDesk: "Edit Cash Desk",
    editChannel: "Edit Channel",
    editCity: "Edit City",
    editChannelClientCompositionMapping: "Edit Channel Client Composition Mapping",
    editChannelHotelRateCodeMapping: "Edit Channel Hotel Rate Code Mapping",
    editChannelHotelRoomTypeMapping: "Edit Channel Hotel Room Type Mapping",
    editCountry: "Edit Country",
    editCreditCardType: "Edit Credit Card Type",
    editGeneralJournal: "Edit General Journal",
    editJournalAccountType: "Edit Journal Account Type",
    editJournalBatch: "Edit Journal Batch",
    editJournalTemplate: "Edit Journal Template",
    editRoomStatus: "Edit Room Status",
    editRoomType: "Edit Room Type",
    editCost: "Edit Cost",
    editRemainingQuantity: "Edit Remaining Quantity",
    editRemainingAmount: "Edit Remaining Amount",
    editRemainingAmountWarning: "Be careful: this directly overwrites the remaining amount and open status of a posted ledger entry. Make sure to check related entries afterwards.",
    internalToolsPostBatchReceipt: "Internal Tools Post Batch",
    internalToolsPostBatchReceiptHint: "Posts released purchase orders for this hotel whose order date falls in the range you set, oldest first, as fully received purchase receipts, up to the limit you set. Receipts are numbered with the prefix exactly as typed, including any trailing space, followed by a running number.",
    internalToolsPostBatchReceiptConfirm: "Post all released purchase orders as fully received purchase receipts?",
    internalToolsPostBatchReceiptFailed: "Failed to post",
    internalToolsPostBatchReceiptNoOrders: "There are no released purchase orders to post.",
    internalToolsPostBatchReceiptDone: "Posted {posted}, failed {failed}.",
    orderDateFrom: "Order Date From",
    orderDateTo: "Order Date To",
    documentNoPrefix: "Document No Prefix",
    documentNoPrefixInvalid: "Prefix contains characters that are not allowed.",
    maxOrdersPerRun: "Max Orders Per Run",
    maxOrdersPerRunInvalid: "Enter a whole number between 1 and {v}.",
    editStoreRequisitionPosted: "Edit Store Requisition Posted",
    entryNo: "Entry No.",
    failed: "Failed",
    failedToPrint: "Failed to print",
    food: "Food",
    foodToday: "Food Today",
    frontOffice: "Front Office",
    generalJournal: "General Journal",
    genProdPostGroupID: "Gen Prod Post Group ID",
    glAccountID: "GL Account ID",
    glAccountName: "GL Account Name",
    glAccountNo: "GL Account No",
    guestNumber: "Guest Number",
    headerDescription: "Header Description",
    headerClientName: "Header Client Name",
    headerClientAddress: "Header Client Address",
    hotelAgency: "Hotel Agency",
    hotelAgencyGroup: "Hotel Agency Group",
    hotelClient: "Hotel Client",
    hotelRate: "Hotel Rate",
    hotelRoomType: "Hotel Room Type",
    importUnitCost: "Import Unit Cost",
    importQuantity: "Import Quantity",
    iso2Code: "ISO2 Code",
    journalAccountNo: "Journal Account No.",
    journalAccountType: "Journal Account Type",
    journalBatch: "Journal Batch",
    journalTemplate: "Journal Template",
    latitude: "Latitude",
    lineDescription: "Line Description",
    lineLocationID: "Line Location ID",
    lineLocationName: "Line Location Name",
    lineNo: "Line No.",
    lineUnitOfMeasurementID: "Line Unit of Measurement ID",
    lineUnitOfMeasurementName: "Line Unit of Measurement Name",
    longitude: "Longitude",
    macro: {
      cost: "Macro Cost",
      revenue: "Macro Revenue",
    },
    mandatory: "Mandatory",
    marketSegment: "Market Segment",
    masterData: "Master Data",
    month: {
      _: "Month",
      list: {
        full: [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ],
        abbr: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
      },
    },
    name: "Name",
    new: "New",
    no: "No",
    notes: "Notes",
    numericCode: "Numeric Code",
    ofCreditComplimentary: "of Credit - Complimentary",
    ofCreditCover: "of Credit - Cover",
    ofCreditOfficeCheck: "of Credit - Office Check",
    ofCreditEntertainment: "of Credit - Entertainment",
    ofPurchaseReceipt: "of Purchase Receipt",
    ofStoreRequest: "of Store Request",
    officialStateName: "Official State Name",
    originalAmount: "Original Amount",
    paymentTermID: "Payment Term ID",
    paymentTermCode: "Payment Term Code",
    population: "Population",
    populationProper: "Population Proper",
    postingDate: "Posting Date",
    rate: "Rate",
    ranking: "Ranking",
    revenueCenterCode: "Revenue Center Code",
    roomStatus: "Room Status",
    roomType: "Room Type",
    sameName: "Same Name",
    save: "Save",
    simpleMapsCityId: "SimpleMapsCity ID",
    successful: "Successful",
    timezone: "Timezone",
    vatProdPostGroupCode: "VAT Prod Post Group Code",
    vatProdPostGroupID: "VAT Prod Post Group ID",
    whtVatProdPostGroupCode: "WHT VAT Prod Post Group Code",
    whtVatProdPostGroupID: "WHT VAT Prod Post Group ID",
    yes: "Yes",
    googleSheets: "Google Sheets",
    debit: "Debit",
    previousBalance: "Previous Balance",
    billDate: "Bill Date",
    aged: "Aged",
    poNoCoa: "PO Number / COA",
    receiptNoDesc: "Receipt No / Desc",
    processExpired: "Process Expired",
    revertExpired: "Revert Expired",
  },
  m: {
    changeAccountNumberDimensionNotice: "The dimension set of this entry will be replaced with the values below, prefilled from the mandatory dimensions of {account}. Leave the list empty to remove the dimension set.",
    ytdComparisonYearHint: "Number of additional historical years shown in the report (0-3, 0 = off)",
    changeAccountNumberDimensionAssignNotice: "This entry has no dimension set. {account} requires the dimensions below, prefilled with their default values. Confirm or adjust them before saving.",
    confirmDelete:
      "Are you sure you want to delete {f}? This process cannot be undone.",
    err: {
      betLen: "{f} must be between {v1} and {v2} characters",
      ge: "{f} must be more than or equal {v}",
      gt: "{f} must be more than {v}",
      le: "{f} must be less than or equal {v}",
      lt: "{f} must be less than {v}",
      maxLen: "{f} must be maximum {v} characters",
      maxVal: "The maximum value of {f} is {v}{x}",
      minLen: "{f} must be minimum {v} characters",
      minMaxVal: "Value of {f} must be from {v1}{x} to {v2}{x}",
      minVal: "The minimum value of {f} is {v}{x}",
      number: "{f} must be a number, either positive or negative",
      numeric: "{f} must consist only numeric",
      req: "{f} is required",
    },
    revertPostedInvoiceWarning: "This action will remove all related Ledger Entries and set Purchase Invoice document as draft or unposted.",
    revertPostedPurchaseCreditMemoWarning: "This action will remove all related Ledger Entries and set Purchase Credit Memo document as draft or unposted.",
    deletePostedInvoiceWarning: "This action will remove all related Ledger Entries and Purchase Invoice document.",
    deleteSelectedInvoicesWarning:
      "This action will permanently remove the selected invoices and all of their lines. It cannot be undone.",
    deleteSelectedInvoicesCount: "{v} document(s) will be deleted:",
    invoiceWithoutDocumentNo: "(No document number)",
    purchaseBookSummaryTruncated:
      "Totals cover the first {v} records only. Narrow the date range for an exact total.",
    deletePostedPurchaseCreditMemoWarning: "This action will remove all related Ledger Entries and Purchase Credit Memo document.",
    changeCOAAndDescriptionWarning: "This action will update only from the Purchase Invoice line. Please ensure updates are made in General Ledger Entries separately.",
    entryEditorWarning: "Ensure that the accounting period remains open and that your user account has the necessary permissions for user posting setup. Any modifications made on this form will be securely logged.",
    gbeRecallWarning: "Recalling this document permanently removes its entries from General Budget Entry. The entries are archived and can be reviewed under Recalled. To restore them, re-enter the lines in General Budget Journal and post again.",
    gbeRecallSuccess: "{n} budget entries recalled.",
    entryDeleteWarningUpdate: "Ensure that the all data below here will be re-open because of delete action. Any modification made form this action will be securely logged",
    entryDeleteBaleWarningDelete: "Caution: Proceeding with this action will result in the permanent removal of all bank account ledger entries associated with the specified document number. Please ensure that you have verified the accuracy of the document number, as this operation is irreversible. Any modification made form this action will be securely logged",
    entryDeleteDaleWarningDelete: "Caution: Proceeding with this action will result in the permanent removal of all deposit account ledger entries associated with the specified document number. Please ensure that you have verified the accuracy of the document number, as this operation is irreversible. Any modification made form this action will be securely logged",
    errorEmptyDocumentNumber: "Please choose document number first.",
    successDeleteBale: "Bank account ledger entries has been deleted",
    successDeleteDale: "Deposit account ledger entries has been deleted",
    successDeletePostedInvoice: "Posted invoice has been deleted",
    successDeletePostedMemo: "Posted memo has been deleted",
    successMovePurchaseInvoiceLines: "Purchase invoice lines have been moved successfully",
    movePurchaseInvoiceLinesWarning: "This action will move all lines from the selected source purchase invoice to the target purchase invoice. Please ensure you have selected the correct invoices as this operation cannot be undone.",
    pleaseSelectTargetPurchaseInvoice: "Please select a target purchase invoice",
    pleaseSelectPurchaseInvoiceFromTheList: "Please select a purchase invoice from the list first",
    sourceTargetPurchaseInvoiceCannotBeSame: "Source and target purchase invoices cannot be the same",
    setVendorChangePriceReminder: "The cost will be determined based on the vendor's contract price whenever such pricing is available",
    successChangeStatusPurchaseRequisition: "Purchase requisition status has been updated",
    successImportGlb: "General ledger budget has been imported successfully!",
    successSaveGlb: "General ledger budget has been saved successfully!",
    successImportCfb: "Cash flow budget has been imported successfully!",
    successSaveCfb: "Cash flow budget has been saved successfully!",
    entryDeleteCleWarningDelete: "Caution: Proceeding with this action will result in the permanent removal of all client ledger entries associated with the specified document number. Please ensure that you have verified the accuracy of the document number, as this operation is irreversible. Any modification made form this action will be securely logged",
    entryDeleteVleWarningDelete: "Caution: Proceeding with this action will result in the permanent removal of all vendor ledger entries associated with the specified document number. Please ensure that you have verified the accuracy of the document number, as this operation is irreversible. Any modification made form this action will be securely logged",
    entryDeleteVeWarningDelete: "Caution: Proceeding with this action will result in the permanent removal of all value entries associated with the specified document number. Please ensure that you have verified the accuracy of the document number, as this operation is irreversible. Any modification made form this action will be securely logged",
    entryDeleteGjeWarningDelete: "Caution: Proceeding with this action will result in the permanent removal of all general journal log associated with the specified document number. Please ensure that you have verified the accuracy of the document number, as this operation is irreversible. Any modification made form this action will be securely logged",
    deleteGeneralJournalLogWarning: "This will not delete General Ledger Entries, only this log.",
    successDeleteCle: "Client ledger entries has been deleted",
    successDeleteVle: "Vendor ledger entries has been deleted",
    successDeleteVe: "Value entries has been deleted",
    successUpdateWitholdingTax: "Witholding Tax has been updated",
    successChangeClientSales: "Client has been updated",
    confirmLogout: "Are you sure want to logout?",
    confirmFlushSiteData: "Are you sure you want to clear site data? This will log you out and refresh the page.",
    successFlushSiteData: "Site data cleared. You will be signed out, and the page will now refresh.",
    successChangeBankAccount: "Bank account has been changed",
    currBankAccount: "Current Bank Account",
    successChangeClient: "Client has been changed",
    currClient: "Current Client",
    successChangeDepositAccount: "Deposit account has been changed",
    currDepositAccount: "Current Deposit Account",
    successChangeVendor: "Vendor has been changed",
    currVendor: "Current Vendor",
    successChangeDeliveryNo: "Delivery no has been changed",
    currDeliveryNo: "Current Delivery No",
    newDeliveryNo: "New Delivery No",
    successCreatePaymentJournal: "Payment Journal has been created",
    successCreateCashReceiptJournal: "Cash Receipt Journal has been created",
    failedZeroRemainingAmount: "Cannot proceed. Some data has zero remaining amount",
    failedAppliedEntries: "Cannot proceed. Some data has been applied entries on payment",
    remainingAmountNotEqualOriginalAmount: "Remaining Amount is not equal to Original Amount",
    noDimensionsConfigured: "No dimensions configured for this report yet.",
    noDimensionsAvailable: "All of this hotel's dimensions are already added.",
    dimensionCountNone: "no dimensions",
    dimensionCountOne: "1 dimension",
    dimensionCountMany: "{count} dimensions",
    saveDimensionOrderFirst: "Save the current order before adding another dimension.",
  },
  common: {
    add: "Add",
    cancel: "Cancel",
    description: "Description",
    delete: "Delete",
    title: "Title",
    save: "Save",
    faq: "FAQ",
    contact: "Contact Us",
    tos: "Terms of Service",
    policy: "Privacy Policy",
    sunday: "Sunday",
    monday: "Monday",
    tuesday: "Tuesday",
    wednesday: "Wednesday",
    thursday: "Thursday",
    friday: "Friday",
    saturday: "Saturday",
    clickHere: "Click here",
    standard: "Standard",
    monospace: "Monospace",
    left: "Left",
    center: "Center",
    right: "Right",
  },
  board: {
    titlePlaceholder: "Enter a title for this card",
    deleteDescription: "Are you sure you want to delete this card?",
    editCard: "Edit Card",
    deleteCard: "Delete Card",
    state: {
      TODO: "TO DO",
      INPROGRESS: "INPROGRESS",
      TESTING: "TESTING",
      DONE: "DONE",
    },
  },
  chat: {
    online: "Users Online ({count})",
    addChannel: "Add Channel",
    channel: "Channel | Channels",
    message: "Message",
  },
  email: {
    compose: "Compose Email",
    send: "Send",
    subject: "Subject",
    labels: "Labels",
    emptyList: "Empty email list",
    inbox: "Inbox",
    sent: "Sent",
    drafts: "Drafts",
    starred: "Starred",
    trash: "Trash",
    work: "Work",
    invoice: "Invoice",
    recipient: "Recipient",
  },
  todo: {
    addTask: "Add Task",
    tasks: "Tasks",
    completed: "Completed",
    labels: "Labels",
  },
  dashboard: {
    activity: "Activity",
    weeklySales: "Weekly Sales",
    sales: "Sales",
    recentOrders: "Recent Orders",
    sources: "Traffic Sources",
    lastweek: "vs last week",
    orders: "Orders",
    clients: "Clients",
    tickets: "Support Tickets",
    viewReport: "View Report",
  },
  usermenu: {
    profile: "Profile",
    signin: "Sign In",
    dashboard: "Dashboard",
    signout: "Sign Out",
  },
  error: {
    syncPrLineFailed: "Failed to sync changes to Purchase Request line. PO changes were saved.",
    failedFetchItemCost: "Failed to fetch latest item cost",
    glbImport: "Error, cannot import general ledger budget",
    cfbImport: "Error, cannot import cash flow budget",
    differentVATGroup: "VAT product posting groups must be the same",
    notfound: "Page Not Found",
    other: "An Error Ocurred",
    invoiceAlreadyHaveCreditMemo: "This invoice already has a Credit Memo",
    POItemIsFromPR:
      "Purchase Order item where the source is coming from Purchase Request",
    locationAndPostingGroupDuplicate:
      "This location ({f1}) and posting group ({f2}) already exist.<br/>Please choose another value!",
    businessAndProductPostingGroupDuplicate:
      "This business ({f1}) and product posting group ({f2}) already exist.<br/>Please choose another value!",
    invoiceAlreadyPaid:
      "This invoice has been paid in part or in full.<br/>Original Amount: {f1}<br/>Remaining Amount: {f2}",
    needConfigureVatProduct: "Please setup VAT Product Posting in Client or Receivable Setup",
    needConfigureDirectCostAccount: "Please setup Direct Cost Applied Account in Purchase Payable Setup",
    needConfigurePurchaseAccount: "Please setup Purchase Account in Purchase Payable Setup",
    noPermission: "You don't have permission to perform this action",
    noAppliedEntriesOnThisDocument: "No Applied entries on this document",
    noCompanyHeaderInfo: "No Company header information. Please contact your admin.",
  },
  check: {
    title: "Set New Password",
    backtosign: "Back to Sign In",
    newpassword: "New Password",
    button: "Set new password and Sign in",
    error: "The action link is invalid",
    verifylink: "Verifying link...",
    verifyemail: "Verifying email address...",
    emailverified: "Email verified! Redirecting...",
  },
  forgot: {
    title: "Forgot Password?",
    subtitle:
      "Enter your account email address and we will send you a link to reset your password.",
    email: "Email",
    button: "Request Password Reset",
    backtosign: "Back to Sign In",
  },
  login: {
    title: "Sign In",
    email: "Email",
    password: "Password",
    button: "Sign In",
    orsign: "Or sign in with",
    forgot: "Forgot password?",
    noaccount: "Don't have an account?",
    create: "Create one here",
    error: "The email / password combination is invalid",
  },
  register: {
    title: "Create Account",
    name: "Full name",
    email: "Email",
    password: "Password",
    passwordRetype: "Retype Password",
    button: "Create Account",
    orsign: "Or sign up with",
    agree: "By signing up, you agree to the",
    account: "Already have an account?",
    signin: "Sign In",
  },
  utility: {
    maintenance: "In Maintenance",
  },
  faq: {
    call: "Have other questions? Please reach out ",
  },
  ecommerce: {
    products: "Products",
    filters: "Filters",
    collections: "Collections",
    priceRange: "Price Range",
    clientReviews: "Client Reviews",
    up: "and up",
    brand: "Brand",
    search: "Search for product",
    results: "Results ( {0} of {1} )",
    orders: "Orders",
    shipping: "Shipping",
    freeShipping: "Free Shipping",
    inStock: "In Stock",
    quantity: "Quantity",
    addToCart: "Add To Cart",
    buyNow: "Buy Now",
    price: "Price",
    about: "About this item",
    description: "Description",
    reviews: "Reviews",
    details: "Product Details",
    cart: "Cart",
    summary: "Order Summary",
    total: "Total",
    discount: "Discount",
    subtotal: "Subtotal",
    continue: "Continue Shopping",
    checkout: "Checkout",
  },
  menu: {
    rateManagement: "Rate Management",
    reservation: "Reservation",
    reservationNew: "New",
    reservationList: "List",
    frontOffice: "Front Office",
    generalSettings: "General Settings",
    guestTitle: "Guest Title",
    guestDocumentType: "Guest Document Type",
    manageHotel: "Hotel",
    hotel: "Hotel",
    hotelList: "List",
    hotelCategory: "Hotel Category",
    hotelChain: "Hotel Chain",
    marketSegment: "Market Segment",
    rooms: "Rooms",
    currency: "Currency",
    search: "Search (press \"ctrl + /\" to focus)",
    dashboard: "Dashboard",
    logout: "Logout",
    flushSiteData: "Clear Site Data",
    clearCache: "Clear Cache",
    profile: "Profile",
    blank: "Blank Page",
    pages: "Pages",
    others: "Others",
    email: "Email",
    chat: "Chat",
    todo: "Todo",
    board: "Task Board",
    users: "Users",
    usersList: "List",
    usersEdit: "Edit",
    ecommerce: "Ecommerce",
    ecommerceList: "Products",
    ecommerceProductDetails: "Product Details",
    ecommerceOrders: "Orders",
    ecommerceCart: "Cart",
    auth: "Auth Pages",
    authLogin: "Signin / Login",
    authRegister: "Signup / Register",
    authVerify: "Verify Email",
    authForgot: "Forgot Password",
    authReset: "Reset Password",
    errorPages: "Error Pages",
    errorNotFound: "Not Found / 404",
    errorUnexpected: "Unexpected / 500",
    utilityPages: "Utility Pages",
    utilityMaintenance: "Maintenance",
    utilitySoon: "Coming Soon",
    utilityHelp: "FAQs / Help",
    levels: "Menu Levels",
    disabled: "Menu Disabled",
    docs: "Documentation",
    feedback: "Feedback",
    support: "Support",
    history: "History",
  },
  localColumns: {
    defaultVatProductPostingGroup: "Default VAT Product Posting Group",
    defaultWhtProductPostingGroup: "Default WHT Product Posting Group",
    postingGroup: "Posting Group",
    postingType: "Posting Type",
    inventoryPostingType: "Inventory Posting Type",
    isWitholdingTax: "Is Witholding Tax",
    isNoVat: "Is No VAT",
    ilePostingDate: "ILE Posting Date",
    batchName: "Batch Name",
    batchCode: "Batch Code",
    totalRecords: "Total Records",
    totalAmount: "Total Amount",
    totalDebit: "Total Debit",
    totalCredit: "Total Credit",
    journalName: "Journal Name",
    company: "Company",
    offsetCompany: "Offset Company",
    offsetAccount: "Offset Account",
    isPom: "Is POM?",
    sentecAccountNo: "Sentec Account No",
    sentecAccountName: "Sentec Account Name",
    salesPersonName: "Sales Person Name",
    guestAccountName: "Guest / Account Name",
    contactPersonName: "Contact Person Name",
    creditLimit: "Credit Limit",
    remainingBalance: "Remaining Balance",
    vleAmount: "VLE Amount",
    gleAmount: "GLE Amount",
    cleAmount: "CLE Amount",
    diff: "Diff",
    SOHQuantity: "SOH Quantity",
    IABQuantity: "IAB Quantity",
    SOHTotalCost: "SOH Total Cost",
    COAAmount: "COA Amount",
    costDifference: "Cost Difference",
    isGeneralStorage: "Is General Storage",
    generalLedgerEntryId: "General Ledger Entry ID",
    operator: "Operator",
    receivableDate: "Receivable Date",
    receivableDueDate: "Receivable Due Date",
    receivablePostingDate: "Receivable Posting Date",
  },
  localCommon: {
    noMenuMatchedWithSearchQuery: "No Menu Matched With Search Query",
    top10VendorByBalance: "Top 10 Vendor by Balance",
    top10ClientsByBalance: "Top 10 Clients by Balance",
    chooseTime: "Choose Time",
    top10PurchaseItem: "Top 10 Purchase Item",
    adjustEntry: "Adjust Entry",
    split: "Split",
    postBatch: "Post Batch",
    processing: "Processing",
    generalLedgerBudget: "General Ledger Budget",
    inventory: "Inventory",
  },
  coaIntegration: {
    title: "COA Integration",
    titleMapping: "COA Mapping",
    provider: "Provider",
    dataLog: "Data Log",
    flushDataLog: "Flush Data",
    successSaveConfig: "Configuration has been updated",
    successGenerateData: "Data has been generated",
    successSendData: "Data has been processed, please check the response",
    successFlushData: "Data log has been flushed",
    successUpdateMappingData: "Mapping has been updated",
    successDeleteMappingData: "Mapping has been deleted",
    inputSystemChartOfAccount: "System Chart Of Account",
    deleteMappingConfirm: "Are you sure want to delete this record? this process cannot be undone.",
    deleteDataLogByMonthConfirm: "Are you sure want to delete all records based on selected month? this process cannot be undone.",
    deleteDataLogAllConfirm: "Are you sure want to delete all records? this process cannot be undone.",
    baseUrl: "Base URL"
  },
  generalLedgerBudget: {
    editTitle: "Edit Budget",
    title: "Import From XLS",
    successImportData: "Data has been imported!",
  },
  cashFlowBudget: {
    editTitle: "Edit Budget",
    title: "Import From XLS",
    successImportData: "Data has been imported!",
  },
  balanceSheetConsolidation: {
    title: "Balance Sheet Consolidation",
    titleReport: "Balance Sheet Consolidation Report",
    excelFileID: "Balance Sheet Consolidation Excel File ID",
    sheetFileID: "Balance Sheet Consolidation Google Sheet File ID",
  },

  $vuetify: {
    badge: "Badge",
    close: "Close",
    dataIterator: {
      noResultsText: "No matching records found",
      loadingText: "Loading items...",
    },
    dataTable: {
      itemsPerPageText: "Rows per page:",
      ariaLabel: {
        sortDescending: "Sorted descending.",
        sortAscending: "Sorted ascending.",
        sortNone: "Not sorted.",
        activateNone: "Activate to remove sorting.",
        activateDescending: "Activate to sort descending.",
        activateAscending: "Activate to sort ascending.",
      },
      sortBy: "Sort by",
    },
    dataFooter: {
      itemsPerPageText: "Items per page:",
      itemsPerPageAll: "All",
      nextPage: "Next page",
      prevPage: "Previous page",
      firstPage: "First page",
      lastPage: "Last page",
      pageText: "{0}-{1} of {2}",
    },
    datePicker: {
      itemsSelected: "{0} selected",
      nextMonthAriaLabel: "Next month",
      nextYearAriaLabel: "Next year",
      prevMonthAriaLabel: "Previous month",
      prevYearAriaLabel: "Previous year",
    },
    noDataText: "No data available",
    carousel: {
      prev: "Previous visual",
      next: "Next visual",
      ariaLabel: {
        delimiter: "Carousel slide {0} of {1}",
      },
    },
    calendar: {
      moreEvents: "{0} more",
    },
    fileInput: {
      counter: "{0} files",
      counterSize: "{0} files ({1} in total)",
    },
    timePicker: {
      am: "AM",
      pm: "PM",
    },
    pagination: {
      ariaLabel: {
        wrapper: "Pagination Navigation",
        next: "Next page",
        previous: "Previous page",
        page: "Goto Page {0}",
        currentPage: "Current Page, Page {0}",
      },
    },
  },
  userPostingSetup: {
    setPostingDate: "Set Posting Date All Users",
  },
  purchaseRequisitionBatch: {
    allowedApprovalSubmissionDays: "Allowed Approval Submission Days",
  },
  documentFlow: {
    purchaseInvoiceDefaultDocumentFlow: "Purchase Invoice Default Document Flow",
    purchaseInvoiceDocumentFlowRules: "Purchase Invoice Document Flow Rules",
    equal: "Equal",
    notEqual: "Not Equal",
    lessThan: "Less Than",
    lessThanOrEqual: "Less Than or Equal",
    greaterThan: "Greater Than",
    greaterThanOrEqual: "Greater Than or Equal",
    purchaseOrderDocumentFlowRules: "Purchase Order Document Flow Rules",
    purchaseReceiptDocumentFlowRules: "Purchase Receipt Document Flow Rules",
    default: "Default Document Flow",
    purchaseOrderDMLDocumentFlowRules: "Purchase Order DML Document Flow Rules",
    documentsSourceInformation: "The documents displayed on this page are exclusively from the Back Office (e.g. PI, PO, PR, etc.). Documents generated by the Front Office can be viewed in the Front Office module.",
    refreshApprovals: "Refresh Approvals",
    showInformation: "Show Information",
    submitForApprovalConfirmation: "Approval requests will be sent via email to these users. Please make sure the information is correct.",
    hideInformation: "Hide Information",
    documentFlowBeingUsed: "Document Flow Being Used",
    sendEmail: "Send Email",
    sendReminder: "Send Reminder",
    reminderCount: "Reminder Count",
    remindedAt: "Reminded At",
  },
  changesLog: {
    logCategory: "Log Category",
    sourceId: "Source ID",
  },
  taxSubmission: {
    availableToCancelOrReject: "Available to cancel/reject",
    availableToGetSubmittedDetails: "Available to get submitted details",
    availableToSend: "Available to send",
    buyerAddress: "Buyer Address",
    buyerContractName: "Buyer Contract Name",
    buyerName: "Buyer Name",
    buyerRegistrationNumber: "Buyer Registration Number",
    buyerSSTRegistrationID: "Buyer SST Registration ID",
    buyerTIN: "Buyer TIN",
    classification: "Classification",
    eInvoice: "e-Invoice",
    eInvoiceCode: "e-Invoice code",
    eInvoiceType: "e-Invoice Type",
    eInvoiceVersion: "e-Invoice version",
    invoiceDateAndTime: "Invoice Date and Time",
    originalInvoiceRefNo: "Original Invoice Ref. No: Not Applicable",
    sendCountInvoicesToTaxInterface: "Send {count} invoices to tax interface",
    subtotal: "Subtotal",
    supplierBusinessActivityDescription: "Supplier business activity description",
    supplierMSICCode: "Supplier MSIC code",
    supplierRegistrationNumber: "Supplier Registration Number",
    supplierSSTID: "Supplier SST ID",
    supplierTIN: "Supplier TIN",
    taxRate: "Tax Rate",
    totalExcludingTax: "Total excluding tax",
    totalIncludingTax: "Total including tax",
    totalPayableAmount: "Total payable amount",
    uniqueIdentifierNo: "Unique Identifier No",
    unitPrice: "Unit Price",
    digitalSignature: "Digital Signature",
    validationDateTime: "Date and Time of Validation",
    visualPresentation: "This document is a visual presentation of the e-Invoice",
    na: "NA",
    getSubmittedDocumentURL: "Get Submitted Document URL",
    cancelOrRejectDocument: "Cancel Or Reject Document",
    interfaceStatus: "Interface Status",
    receiptVerificationRedirectURL: "Receipt Verification Redirect URL",
    receiptVerificationSubmissionUUID: "Receipt Verification Submission UUID",
    receiptVerificationDocumentUUID: "Receipt Verification Document UUID",
    reject: "Reject"
  },
  template: {
    columnLengthDifference: "Invalid template: column count does not match."
  }
};
